import { useState, useEffect } from "react";
import { auth } from "./firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import Login from "./Login";
import {
  saveProfile,
  getProfile,
  createGroup,
  joinGroupByCode,
  deleteGroup as deleteGroupDB,
  leaveGroup as leaveGroupDB,
  updateGroup,
  listenToGroups,
  addItem as addItemDB,
  updateItem,
  deleteItem as deleteItemDB,
  logActivity as logActivityDB,
  listenToActivity,
  listenToItems,
  getGroupByCode,
  getItemsOnce,
  listenToDeals,
  addDeal,
  updateDeal,
  deleteDeal,
} from "./db";

const GOLD = "#F0B323";
const ADMIN_UID = "FrUht4rjN2eSFHrMX7gyvHSUHj43";
const MEMBER_COLORS = ["#F0B323","#10b77a","#e05a8a","#2a6aee","#9b6aee","#20c0d0"];
const AMAZON_COLOR = "#F0B323";

const SCHOOLS = [
  { value: "UMBC", label: "University of Maryland, Baltimore County (UMBC)" },
  { value: "UMD", label: "University of Maryland, College Park (UMD)" },
];

// Approximate room dimensions — users can edit after auto-fill
// Room dimensions per hall and room type.
// UMBC: official ResLife dimensions. UMD: estimates (UMD does not publish sizes).
const DORM_PRESETS = {
  UMBC: [
    { name: "Chesapeake Hall", types: { Single: { length: 10, width: 9 }, Double: { length: 18, width: 10 }, Triple: { length: 18, width: 16 } } },
    { name: "Erickson Hall (suite)", types: { Single: { length: 11, width: 8 }, Double: { length: 15, width: 10 } } },
    { name: "Harbor Hall (suite)", types: { Single: { length: 11, width: 8 }, Double: { length: 15, width: 10 } } },
    { name: "Hillside Apartments", note: "Bedroom size only — living room & kitchen not included", types: { Bedroom: { length: 10, width: 8 } } },
    { name: "Patapsco Hall", types: { Single: { length: 10, width: 9 }, Double: { length: 18, width: 10 }, Triple: { length: 18, width: 16 } } },
    { name: "Potomac Hall", types: { Single: { length: 10, width: 9 }, Double: { length: 18, width: 10 }, Triple: { length: 18, width: 16 } } },
    { name: "Susquehanna Hall", types: { Single: { length: 10, width: 9 }, Double: { length: 18, width: 10 }, Triple: { length: 18, width: 16 } } },
    { name: "Terrace Apartments", note: "Bedroom size only — living room & kitchen not included", types: { Bedroom: { length: 10, width: 8 } } },
    { name: "Walker Avenue Apartments", note: "Bedroom size only — living room & kitchen not included", types: { Bedroom: { length: 10, width: 9 } } },
    { name: "West Hill Apartments", note: "Bedroom size only — living room & kitchen not included", types: { Bedroom: { length: 10, width: 9 } } },
  ],
  UMD: [
    { name: "Allegany Hall", estimated: true, note: "Bedroom size only — apartment/suite style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "Anne Arundel Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Baltimore Hall", estimated: true, note: "Bedroom size only — apartment/suite style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "Bel Air Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Calvert Hall", estimated: true, note: "Bedroom size only — apartment/suite style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "Cambridge Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Caroline Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Carroll Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Cecil Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Centreville Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Charles Hall", estimated: true, note: "Bedroom size only — apartment/suite style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "Chestertown Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Cumberland Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Denton Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Dorchester Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Easton Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Elkton Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Ellicott Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Frederick Hall", estimated: true, note: "Bedroom size only — apartment/suite style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "Garrett Hall", estimated: true, note: "Bedroom size only — apartment/suite style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "Hagerstown Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Harford Hall", estimated: true, note: "Bedroom size only — apartment/suite style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "Howard Hall", estimated: true, note: "Bedroom size only — apartment/suite style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "Johnson-Whittle Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 15, width: 12 } } },
    { name: "Kent Hall", estimated: true, note: "Bedroom size only — apartment/suite style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "La Plata Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Leonardtown", estimated: true, note: "Bedroom size only — apartment style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "Montgomery Hall", estimated: true, note: "Bedroom size only — apartment/suite style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "Oakland Hall (semi-suite)", estimated: true, types: { Single: { length: 11, width: 9 }, Double: { length: 15, width: 12 } } },
    { name: "Prince Frederick Hall (semi-suite)", estimated: true, types: { Single: { length: 11, width: 9 }, Double: { length: 15, width: 12 } } },
    { name: "Prince George's Hall", estimated: true, note: "Bedroom size only — apartment/suite style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "Pyon-Chen Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 15, width: 12 } } },
    { name: "Queen Anne's Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Somerset Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "St. Mary's Hall", estimated: true, note: "Bedroom size only — apartment/suite style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "Talbot Hall", estimated: true, note: "Bedroom size only — apartment/suite style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "Washington Hall", estimated: true, note: "Bedroom size only — apartment/suite style", types: { Bedroom: { length: 12, width: 10 } } },
    { name: "Wicomico Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
    { name: "Worcester Hall", estimated: true, types: { Single: { length: 12, width: 9 }, Double: { length: 16, width: 12 }, Triple: { length: 16, width: 14 } } },
  ],
};

// Per-school commonly prohibited items (merged with the general banned list)
const SCHOOL_BANNED = {
  UMBC: ["Air Conditioner", "Toaster Oven", "Deep Fryer", "Electric Blanket", "Sandwich Maker", "Wireless Router"],
  UMD: ["Air Conditioner", "Toaster Oven", "Deep Fryer", "Electric Blanket", "Wireless Router", "Ceiling Fan"],
};

const ESSENTIALS = {
  Bedroom: [
    { name: "Twin XL Mattress Topper", cost: 45 },
    { name: "Twin XL Sheet Set", cost: 30 },
    { name: "Pillow (2-pack)", cost: 25 },
    { name: "Comforter/Duvet", cost: 50 },
    { name: "Bed Risers", cost: 15 },
    { name: "Under-Bed Storage Bins", cost: 20 },
    { name: "Hangers (50-pack)", cost: 12 },
    { name: "Laundry Hamper", cost: 18 },
    { name: "Full-Length Mirror", cost: 35 },
    { name: "Alarm Clock", cost: 20 },
  ],
  Bathroom: [
    { name: "Shower Caddy", cost: 18 },
    { name: "Shower Flip Flops", cost: 10 },
    { name: "Microfiber Towels (3-pack)", cost: 22 },
    { name: "Toiletry Bag", cost: 15 },
    { name: "Bathrobe", cost: 30 },
    { name: "Hair Dryer", cost: 25 },
    { name: "Over-Door Hook", cost: 10 },
    { name: "First Aid Kit", cost: 20 },
  ],
  Kitchen: [
    { name: "Mini Fridge", cost: 89 },
    { name: "Microwave", cost: 65 },
    { name: "Electric Kettle", cost: 25 },
    { name: "Reusable Water Bottle", cost: 20 },
    { name: "Coffee Maker", cost: 35 },
    { name: "Plates & Bowls Set", cost: 22 },
    { name: "Utensil Set", cost: 15 },
    { name: "Can Opener", cost: 8 },
    { name: "Dish Drying Rack", cost: 14 },
    { name: "Storage Containers", cost: 18 },
  ],
  "Study/Desk": [
    { name: "Desk Lamp", cost: 24 },
    { name: "Desk Organizer", cost: 16 },
    { name: "Whiteboard (small)", cost: 18 },
    { name: "Bulletin Board", cost: 14 },
    { name: "Drawer Organizer", cost: 12 },
    { name: "Stapler & Hole Punch", cost: 10 },
    { name: "Sticky Notes (bulk)", cost: 8 },
    { name: "Printer (if needed)", cost: 80 },
  ],
  "Tech/Electronics": [
    { name: "Surge Protector (6-outlet)", cost: 20 },
    { name: "Extension Cord", cost: 12 },
    { name: "USB-C Hub", cost: 30 },
    { name: "Bluetooth Speaker", cost: 40 },
    { name: "Laptop Stand", cost: 25 },
    { name: "Webcam", cost: 35 },
    { name: "Noise-Cancelling Headphones", cost: 80 },
    { name: "LED Desk Strip Lights", cost: 18 },
    { name: "Smart Plug (4-pack)", cost: 22 },
  ],
  "Shared/Common Area": [
    { name: "TV (32-inch)", cost: 180 },
    { name: "HDMI Cable", cost: 10 },
    { name: "Small Couch/Futon", cost: 150 },
    { name: "Area Rug", cost: 45 },
    { name: "Wall Art / Posters", cost: 20 },
    { name: "String Lights", cost: 12 },
    { name: "Room Divider Curtain", cost: 30 },
  ],
  Laundry: [
    { name: "Laundry Detergent (HE)", cost: 18 },
    { name: "Dryer Sheets", cost: 8 },
    { name: "Mesh Laundry Bags", cost: 10 },
    { name: "Wrinkle Release Spray", cost: 8 },
    { name: "Portable Steamer", cost: 30 },
    { name: "Quarters Roll (for machines)", cost: 10 },
  ],
  "Health & Safety": [
    { name: "Hand Sanitizer", cost: 8 },
    { name: "Face Masks (box)", cost: 10 },
    { name: "Vitamins / Supplements", cost: 20 },
    { name: "Cold Medicine Kit", cost: 18 },
    { name: "Thermometer", cost: 12 },
    { name: "Personal Lock (for storage)", cost: 10 },
    { name: "Doorstop Alarm", cost: 14 },
    { name: "Pepper Spray / Personal Safety", cost: 15 },
  ],
};

const DORM_WARNINGS = {
  "Mini Fridge": { sqft: 4, note: "Check your dorm's appliance policy - some limit fridge size to 3.2 cu ft" },
  "Microwave": { sqft: 3, note: "Many dorms ban microwaves above 700W. Verify your school's policy." },
  "TV (32-inch)": { sqft: 6, note: "A 32 inch TV needs at least a 3-foot wide surface. Measure your desk first." },
  "Small Couch/Futon": { sqft: 25, note: "Futons take significant floor space. Common in bigger dorms only." },
  "Area Rug": { sqft: 20, note: "Large rugs can make a small room feel cramped. Consider a 4x6 max." },
  "Printer (if needed)": { sqft: 4, note: "Campus print centers are usually free - consider skipping a personal printer." },
};

const BANNED_ITEMS = ["Candle","Incense","Space Heater","Halogen Lamp","George Foreman Grill","Hot Plate","Toaster","Air Fryer"];

const KEY_ESSENTIALS = [
  { name: "Trash Can", cost: 12 },
  { name: "Shower Caddy", cost: 18 },
  { name: "Surge Protector (6-outlet)", cost: 20 },
  { name: "First Aid Kit", cost: 20 },
  { name: "Laundry Hamper", cost: 18 },
  { name: "Paper Towels", cost: 15 },
  { name: "Cleaning Wipes", cost: 8 },
  { name: "Command Strips", cost: 10 },
];

const CUBIC_FT = {
  "Mini Fridge": 5, "Microwave": 2, "TV (32-inch)": 4, "Small Couch/Futon": 20,
  "Area Rug": 2, "Printer (if needed)": 2, "Comforter/Duvet": 2,
  "Twin XL Mattress Topper": 2, "Under-Bed Storage Bins": 3, "Laundry Hamper": 1.5,
  "Full-Length Mirror": 1.5, "Coffee Maker": 1,
};
const TRUNK_CUFT = 13;

const LAST_SWEEP = [
  "Phone charger", "Laptop + charger", "Medications", "ID / Wallet",
  "Important documents", "Glasses / contacts", "Toiletries bag",
  "Water bottle", "Bedding (if washed last minute)", "Snacks for the drive",
];

const QUESTIONNAIRE = [
  { q: "Will you cook in your dorm?", options: [
    { label: "Yes, often", items: [{ name: "Electric Kettle", cost: 25 }, { name: "Storage Containers", cost: 18 }, { name: "Plates & Bowls Set", cost: 22 }, { name: "Utensil Set", cost: 15 }] },
    { label: "Not really", items: [{ name: "Reusable Water Bottle", cost: 20 }] },
  ]},
  { q: "Bringing a gaming or TV setup?", options: [
    { label: "Yes", items: [{ name: "HDMI Cable", cost: 10 }, { name: "Surge Protector (6-outlet)", cost: 20 }, { name: "LED Desk Strip Lights", cost: 18 }] },
    { label: "No", items: [] },
  ]},
  { q: "Where will you study most?", options: [
    { label: "My room", items: [{ name: "Desk Lamp", cost: 24 }, { name: "Desk Organizer", cost: 16 }, { name: "Whiteboard (small)", cost: 18 }] },
    { label: "Library", items: [{ name: "Laptop Stand", cost: 25 }, { name: "Noise-Cancelling Headphones", cost: 80 }] },
  ]},
  { q: "Doing laundry on campus?", options: [
    { label: "Yes", items: [{ name: "Laundry Detergent (HE)", cost: 18 }, { name: "Mesh Laundry Bags", cost: 10 }, { name: "Quarters Roll (for machines)", cost: 10 }] },
    { label: "Taking it home", items: [{ name: "Laundry Hamper", cost: 18 }] },
  ]},
  { q: "Light sleeper?", options: [
    { label: "Yes", items: [{ name: "Sleep Mask & Earplugs", cost: 12 }] },
    { label: "No", items: [{ name: "Alarm Clock", cost: 20 }] },
  ]},
];

const MOVEOUT_PLANS = ["Sell", "Store", "Take Home", "Roommate Keeps"];

function PieChart({ data, total }) {
  const [hovered, setHovered] = useState(null);
  const cx = 100, cy = 100, r = 75, innerR = 48;
  let cum = -Math.PI / 2;
  const slices = data.map((d, i) => {
    const angle = (d.value / total) * 2 * Math.PI;
    const s = cum, e = cum + angle;
    cum = e;
    const x1 = cx + r * Math.cos(s), y1 = cy + r * Math.sin(s);
    const x2 = cx + r * Math.cos(e), y2 = cy + r * Math.sin(e);
    const large = angle > Math.PI ? 1 : 0;
    return { ...d, path: `M${cx} ${cy}L${x1} ${y1}A${r} ${r} 0 ${large} 1 ${x2} ${y2}Z`, color: MEMBER_COLORS[i % MEMBER_COLORS.length] };
  });
  const active = hovered !== null ? slices[hovered] : null;
  return (
    <svg width={200} height={200} style={{ overflow: "visible" }}>
      {slices.map((s, i) => (
        <path key={i} d={s.path} fill={s.color}
          opacity={hovered !== null && hovered !== i ? 0.35 : 1}
          style={{ transform: hovered === i ? "scale(1.05)" : "scale(1)", transformOrigin: `${cx}px ${cy}px`, transition: "all 0.18s", cursor: "pointer" }}
          onMouseEnter={() => setHovered(i)} onMouseLeave={() => setHovered(null)} />
      ))}
      <circle cx={cx} cy={cy} r={innerR} fill="#0a0a0a" />
      {active ? (
        <>
          <text x={cx} y={cy - 10} textAnchor="middle" fill={active.color} fontSize="12" fontWeight="700" fontFamily="DM Sans">{active.name}</text>
          <text x={cx} y={cy + 8} textAnchor="middle" fill="#f5f0e0" fontSize="16" fontWeight="700" fontFamily="Space Grotesk">${active.value.toFixed(0)}</text>
          <text x={cx} y={cy + 24} textAnchor="middle" fill="#c49020" fontSize="11" fontFamily="DM Sans">{((active.value / total) * 100).toFixed(0)}%</text>
        </>
      ) : (
        <>
          <text x={cx} y={cy - 6} textAnchor="middle" fill="#c49020" fontSize="10" fontFamily="DM Sans" letterSpacing="0.8">TOTAL</text>
          <text x={cx} y={cy + 14} textAnchor="middle" fill="#f5f0e0" fontSize="19" fontWeight="700" fontFamily="Space Grotesk">${total.toFixed(0)}</text>
        </>
      )}
    </svg>
  );
}

function HMLogo({ size = 40 }) {
  const c = GOLD;
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="12" y="20" width="7" height="60" fill={c}/>
      <rect x="12" y="20" width="22" height="7" fill={c}/>
      <rect x="12" y="73" width="22" height="7" fill={c}/>
      <rect x="81" y="20" width="7" height="60" fill={c}/>
      <rect x="66" y="20" width="22" height="7" fill={c}/>
      <rect x="66" y="73" width="22" height="7" fill={c}/>
      <rect x="31" y="30" width="7" height="40" fill={c}/>
      <rect x="62" y="30" width="7" height="40" fill={c}/>
      <rect x="31" y="46" width="38" height="8" fill={c}/>
    </svg>
  );
}

const BASE_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Space+Grotesk:wght@500;700&display=swap');
  *{box-sizing:border-box;margin:0;padding:0;}
  ::-webkit-scrollbar{width:0;height:0;}
  @keyframes spin{to{transform:rotate(360deg);}}
  @keyframes fu{from{opacity:0;transform:translateX(-50%) translateY(10px);}to{opacity:1;transform:translateX(-50%) translateY(0);}}
  .btn-p{background:linear-gradient(135deg,#3d2e00,#1a1400);color:#f5f0e0;border:1px solid #8a6200;border-radius:12px;padding:13px 20px;font-size:15px;font-weight:600;cursor:pointer;width:100%;font-family:'DM Sans',sans-serif;transition:all 0.2s;}
  .btn-p:hover{background:linear-gradient(135deg,#4d3a00,#241c00);}
  .btn-g{background:transparent;color:#d4a830;border:1px solid #4a3800;border-radius:12px;padding:13px 20px;font-size:15px;font-weight:500;cursor:pointer;width:100%;font-family:'DM Sans',sans-serif;transition:all 0.2s;}
  .btn-g:hover{background:#171200;}
  .btn-danger{background:#1a0808;color:#e07070;border:1px solid #4a1a1a;border-radius:12px;padding:13px 20px;font-size:15px;font-weight:600;cursor:pointer;width:100%;font-family:'DM Sans',sans-serif;}
  .card{background:linear-gradient(145deg,#0d0e00,#0a0c00);border:1px solid #2a2000;border-radius:18px;padding:18px;transition:all 0.2s;}
  .card:hover{border-color:#8a6200;}
  .inp{background:#0d0e00;border:1px solid #4a3800;border-radius:12px;padding:13px 16px;color:#f5f0e0;font-size:15px;width:100%;outline:none;font-family:'DM Sans',sans-serif;transition:border 0.2s;}
  .inp:focus{border-color:#F0B323;}
  .inp::placeholder{color:#6a5020;}
  .tag{display:inline-flex;align-items:center;gap:4px;padding:4px 10px;border-radius:20px;font-size:12px;font-weight:600;}
  .tag-b{background:#1a1400;color:#F0B323;border:1px solid #3d2e00;}
  .tag-g{background:#0d2818;color:#4caf80;border:1px solid #1a4a30;}
  .tag-r{background:#2a0d0d;color:#e07070;border:1px solid #4a1a1a;}
  .tag-gray{background:#15140d;color:#6a6050;border:1px solid #242010;}
  .tag-y{background:#2a1a08;color:#e0a050;border:1px solid #4a3010;}
  .modal-bg{position:fixed;inset:0;background:rgba(0,0,0,0.85);z-index:100;display:flex;align-items:flex-end;max-width:430px;margin:0 auto;}
  .modal-sheet{background:#0d0e00;border:1px solid #2a2000;border-radius:24px 24px 0 0;padding:24px;width:100%;display:flex;flex-direction:column;gap:14px;max-height:90vh;overflow-y:auto;}
  .modal-center{position:fixed;inset:0;background:rgba(0,0,0,0.88);z-index:200;display:flex;align-items:center;justify-content:center;padding:24px;max-width:430px;margin:0 auto;}
  .modal-box{background:#0d0e00;border:1px solid #2a2000;border-radius:20px;padding:24px;width:100%;display:flex;flex-direction:column;gap:14px;}
  .toast{position:fixed;bottom:90px;left:50%;transform:translateX(-50%);padding:12px 20px;border-radius:30px;font-size:14px;font-weight:600;z-index:300;white-space:nowrap;animation:fu 0.3s ease;}
  .ts{background:#0d2818;color:#4caf80;border:1px solid #1a4a30;}
  .tw{background:#2a1a0a;color:#e0a050;border:1px solid #4a3010;}
  .ti{background:#1a1400;color:#F0B323;border:1px solid #3d2e00;}
  .tr{background:#2a0808;color:#e07070;border:1px solid #4a1a1a;}
  .row{display:flex;align-items:center;gap:12px;padding:14px 16px;background:#0a0c00;border:1px solid #2a2000;border-radius:14px;transition:all 0.2s;}
  .row:hover{border-color:#8a6200;}
  .tabs{display:flex;background:#0a0c00;border-radius:12px;padding:4px;gap:2px;overflow-x:auto;}
  .tab{flex:1 0 auto;padding:9px 12px;border:none;border-radius:10px;font-size:12px;font-weight:600;cursor:pointer;transition:all 0.2s;font-family:'DM Sans',sans-serif;letter-spacing:0.2px;white-space:nowrap;}
  .tab-a{background:#3d2e00;color:#F0B323;}
  .tab-i{background:transparent;color:#6a5020;}
  .bnav{position:fixed;bottom:0;left:50%;transform:translateX(-50%);width:100%;max-width:430px;background:#0a0a0a;border-top:1px solid #2a2000;display:flex;justify-content:space-around;padding:10px 0 18px;z-index:50;}
  .ni{display:flex;flex-direction:column;align-items:center;gap:3px;cursor:pointer;color:#6a5020;font-size:10px;font-weight:600;padding:4px 12px;border-radius:10px;font-family:'DM Sans',sans-serif;}
  .ni.a{color:#F0B323;}
  .pbar{height:4px;background:#0d0e00;border-radius:4px;overflow:hidden;}
  .pfill{height:100%;background:linear-gradient(90deg,#8a6200,#F0B323);border-radius:4px;transition:width 0.5s;}
  .tgl{width:44px;height:24px;border-radius:12px;border:none;cursor:pointer;position:relative;transition:background 0.2s;flex-shrink:0;}
  .tgl-on{background:#8a6200;}
  .tgl-off{background:#242010;}
  .tgl::after{content:'';position:absolute;width:18px;height:18px;border-radius:50%;background:#f5f0e0;top:3px;transition:left 0.2s;}
  .tgl-on::after{left:23px;}
  .tgl-off::after{left:3px;}
  .prog-ring{transform:rotate(-90deg);}
  .chip{display:inline-flex;align-items:center;gap:6px;padding:6px 12px;border-radius:20px;font-size:12px;font-weight:700;cursor:pointer;border:1px solid #4a3800;background:#0d0e00;color:#d4a830;transition:all 0.18s;font-family:'DM Sans',sans-serif;}
  .chip.sel{background:#3d2e00;border-color:#F0B323;color:#F0B323;}
  select.inp option{background:#0d0e00;color:#f5f0e0;}
  input[type="date"].inp {
    -webkit-appearance: none;
    appearance: none;
    padding-right: 12px;
    background-clip: padding-box;
}
`;

export default function Haulmate() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [screen, setScreen] = useState("loading");  const [profile, setProfile] = useState({ name: "", school: "" });
  const [confirmDelete, setConfirmDelete] = useState(true);
  const [notifications, setNotifications] = useState(true);
  const [groups, setGroups] = useState([]);
  const [groupItems, setGroupItems] = useState({});
  const [activeGroupId, setActiveGroupId] = useState(null);
  const [activeTab, setActiveTab] = useState("list");
  const [showAddItem, setShowAddItem] = useState(false);
  const [showAddGroup, setShowAddGroup] = useState(false);
  const [showJoinGroup, setShowJoinGroup] = useState(false);
  const [showEssentials, setShowEssentials] = useState(false);
  const [showQuestionnaire, setShowQuestionnaire] = useState(false);
  const [showMoveOut, setShowMoveOut] = useState(false);
  const [showMoveInMode, setShowMoveInMode] = useState(false);
  const [qAnswers, setQAnswers] = useState({});
  const [qSuggestions, setQSuggestions] = useState(null);
  const [qSelected, setQSelected] = useState([]);
  const [lastSweepDone, setLastSweepDone] = useState({});
  const [boughtModal, setBoughtModal] = useState(null);
  const [previewData, setPreviewData] = useState(null);
  const [skipPreview, setSkipPreview] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [spaceWarn, setSpaceWarn] = useState(null);
  const [bannedWarn, setBannedWarn] = useState(null);
  const [newItem, setNewItem] = useState({ name: "", cost: "", shared: true });
  const [newGroup, setNewGroup] = useState({ name: "", school: "", hall: "", roomType: "", length: "", width: "", moveInDate: "" });
  const [joinCode, setJoinCode] = useState("");
  const [groceryInput, setGroceryInput] = useState("");
  const [searchQ, setSearchQ] = useState("");
  const [budgetCap, setBudgetCap] = useState("");
  const [essentialCat, setEssentialCat] = useState("Bedroom");
  const [selectedEssentials, setSelectedEssentials] = useState([]);
  const [toast, setToast] = useState(null);
  const [navTab, setNavTab] = useState("home");
  const [activity, setActivity] = useState([]);
  const [deals, setDeals] = useState([]);
  const [showAdminPanel, setShowAdminPanel] = useState(false);
  const [editDeal, setEditDeal] = useState(null);
  const [newDeal, setNewDeal] = useState({ title: "", description: "", link: "", emoji: "🔥" });

useEffect(() => {
    import("firebase/auth").then(({ getRedirectResult }) => {
      getRedirectResult(auth).then((cred) => {
        if (cred?._tokenResponse?.isNewUser) {
          sessionStorage.setItem("haulmate_just_signedup", cred.user.uid);
        }
      }).catch(() => {});
    });
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (!u) {
        setUser(null);
        setAuthLoading(false);
        setScreen("onboard1");
        setGroups([]);
        setGroupItems({});
        return;
      }
      const savedProfile = await getProfile(u.uid);
      const justSignedUp = sessionStorage.getItem("haulmate_just_signedup") === u.uid;

      if (savedProfile && savedProfile.name && savedProfile.school) {
        setProfile({ ...savedProfile });
        setScreen("home");
        setUser(u);
        setAuthLoading(false);
      } else if (justSignedUp) {
        setProfile(p => ({ ...p, name: u.displayName || "" }));
        setScreen("onboard1");
        setUser(u);
        setAuthLoading(false);
      } else {
        await signOut(auth);
        sessionStorage.removeItem("haulmate_just_signedup");
        return;
      }

      const pendingJoin = localStorage.getItem("haulmate_pending_join");
      if (pendingJoin) {
        localStorage.removeItem("haulmate_pending_join");
        const joinName = (savedProfile && savedProfile.name) || u.displayName || "Teammate";
        const res = await joinGroupByCode(u.uid, joinName, pendingJoin, "");
        if (!res.error) {
          window.history.replaceState({}, "", window.location.pathname);
        }
      }
      listenToGroups(u.uid, (fetchedGroups) => {
        setGroups(fetchedGroups);
        fetchedGroups.forEach(group => {
          listenToItems(group.id, (items) => {
            setGroupItems(prev => ({ ...prev, [group.id]: items }));
          });
        });
      });
    });
    return unsub;
  }, []);

  useEffect(() => {
    if (!user) return;
    const checkProfile = async () => {
      const savedProfile = await getProfile(user.uid);
      if (!savedProfile || !savedProfile.name || !savedProfile.school) {
        const justSignedUp = sessionStorage.getItem("haulmate_just_signedup") === user.uid;
        if (!justSignedUp) {
          await signOut(auth);
        }
      }
    };
    const onFocus = () => checkProfile();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [user]);

  // Listen to activity only for the open group
  useEffect(() => {
    if (!activeGroupId) { setActivity([]); return; }
    const unsub = listenToActivity(activeGroupId, setActivity);
    return unsub;
  }, [activeGroupId]);
  useEffect(() => {
    const unsub = listenToDeals(setDeals);
    return unsub;
  }, []);

  // Invite link preview: ?join=CODE
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const codeParam = params.get("join");
    if (codeParam) {
      localStorage.setItem("haulmate_pending_join", codeParam.toUpperCase());
      getGroupByCode(codeParam).then(async (g) => {
        if (g) {
          try {
            const items = await getItemsOnce(g.id);
            setPreviewData({ group: g, items });
          } catch (e) {
            setPreviewData({ group: g, items: [] });
          }
        }
      }).catch(() => {});
    }
  }, []);

  const showToast = (msg, type = "i") => { setToast({ msg, type }); setTimeout(() => setToast(null), 2800); };
  const timeAgo = (ts) => {
    const d = (Date.now() - (ts?.seconds ? ts.seconds * 1000 : ts)) / 1000;
    if (isNaN(d) || d < 60) return "just now";
    if (d < 3600) return `${Math.floor(d/60)}m ago`;
    if (d < 86400) return `${Math.floor(d/3600)}h ago`;
    return `${Math.floor(d/86400)}d ago`;
  };

  const cg = groups.find(g => g.id === activeGroupId);
  const cgAll = (activeGroupId && groupItems[activeGroupId]) || [];
  const cgItems = cgAll.filter(i => i.listType !== "grocery");
  const cgGrocery = cgAll.filter(i => i.listType === "grocery");
  const getDupes = (items) => { const n = items.map(i => i.name.toLowerCase().trim()); return n.filter((x, idx) => n.indexOf(x) !== idx); };
  const dupes = getDupes(cgItems);
  const getTotal = (items) => items.reduce((s, i) => s + Number(i.cost || 0), 0);
  const getMyTotal = (items) => items.filter(i => i.owner === user?.uid).reduce((s, i) => s + Number(i.cost || 0), 0);
  const filteredItems = cgItems.filter(i => i.name.toLowerCase().includes(searchQ.toLowerCase()));
  const myTotal = getMyTotal(cgItems);
  const budgetNum = Number(budgetCap);
  const overBudget = budgetNum > 0 && myTotal > budgetNum;

  const amazonLink = (n) => `https://www.amazon.com/s?k=${encodeURIComponent(n + " dorm")}&tag=haulmate-20`;

  const getDisplayName = (ownerId) => {
    if (!ownerId) return null;
    if (ownerId === user?.uid) return "You";
    if (cg?.memberNames?.[ownerId]) return cg.memberNames[ownerId];
    return "Teammate";
  };

  const daysUntilMoveIn = (g) => {
    if (!g?.moveInDate) return null;
    const diff = Math.ceil((new Date(g.moveInDate + "T00:00:00") - new Date()) / 86400000);
    return diff;
  };

  // Cart: my claimed items across ALL groups
  const myCart = [];
  groups.forEach(g => {
    (groupItems[g.id] || []).forEach(i => {
      if (i.owner === user?.uid && i.listType !== "grocery") {
        myCart.push({ ...i, groupId: g.id, groupName: g.name });
      }
    });
  });
  const cartUnbought = myCart.filter(i => !i.purchased).length;

  const checkSpaceWarn = (name) => {
    if (!cg?.dormDimensions) return false;
    const warn = DORM_WARNINGS[name];
    if (!warn) return false;
    const roomSqft = (cg.dormDimensions.length || 14) * (cg.dormDimensions.width || 12);
    const usedSqft = cgItems.reduce((s, i) => s + (DORM_WARNINGS[i.name]?.sqft || 0), 0);
    if (usedSqft + warn.sqft > roomSqft * 0.4) return warn.note;
    return false;
  };

  const handleAddItem = (groupId) => {
    if (!newItem.name.trim()) return;
    const allBanned = [...BANNED_ITEMS, ...(SCHOOL_BANNED[cg?.school || profile.school] || [])];
    const isBanned = allBanned.some(b => newItem.name.toLowerCase().includes(b.toLowerCase()));
    const spaceNote = checkSpaceWarn(newItem.name);
    const proceed = async () => {
      const dupeNames = getDupes([...cgItems, { name: newItem.name }]);
      const isDupe = dupeNames.includes(newItem.name.toLowerCase().trim());
      await addItemDB(groupId, {
        name: newItem.name,
        cost: Number(newItem.cost) || 0,
        owner: null, retailer: null, purchased: false,
        shared: newItem.shared !== false,
        checked: false, moveOutPlan: null,
        addedBy: user.uid,
        addedByName: profile.name || user.displayName || "You",
      });
      logActivityDB(groupId, `${profile.name || "You"} added ${newItem.name}`);
      if (isDupe) showToast(`"${newItem.name}" conflict detected`, "w");
      else showToast("Item added!", "s");
      setNewItem({ name: "", cost: "", shared: true });
      setShowAddItem(false);
    };
    if (isBanned) { setBannedWarn({ name: newItem.name, proceed }); return; }
    if (spaceNote) { setSpaceWarn({ note: spaceNote, proceed }); return; }
    proceed();
  };

  const handleClaimTap = async (groupId, item) => {
    if (item.owner === user.uid) {
      await updateItem(groupId, item.id, { owner: null, purchased: false });
      logActivityDB(groupId, `${profile.name || "You"} unclaimed ${item.name}`);
      showToast("Unclaimed", "s");
    } else {
      await updateItem(groupId, item.id, { owner: user.uid, purchased: false });
      logActivityDB(groupId, `${profile.name || "You"} claimed ${item.name}`);
      showToast("Claimed!", "s");
    }
  };


  

  const handleBoughtTap = (groupId, item) => {
    if (item.purchased) {
      updateItem(groupId, item.id, { purchased: false });
    } else {
      setBoughtModal({ groupId, item, price: String(item.cost || "") });
    }
  };

  const confirmBought = async () => {
    const { groupId, item, price } = boughtModal;
    await updateItem(groupId, item.id, { purchased: true, cost: Number(price) || item.cost || 0 });
    logActivityDB(groupId, `${profile.name || "You"} bought ${item.name}`);
    setBoughtModal(null);
    showToast("Marked as bought!", "s");
  };

  const handleDeleteItem = (groupId, item) => {
    const doDelete = async () => {
      await deleteItemDB(groupId, item.id);
      logActivityDB(groupId, `${profile.name || "You"} removed ${item.name}`);
      showToast("Item removed", "r");
      setDeleteConfirm(null);
      setEditItem(null);
    };
    if (confirmDelete) setDeleteConfirm({ msg: `Remove "${item.name}" from the list?`, action: doDelete });
    else doDelete();
  };
  const handleLeaveGroup = (groupId) => {
    const doLeave = async () => {
      await leaveGroupDB(groupId, user.uid);
      logActivityDB(groupId, `${profile.name || "You"} left the group`);
      setActiveGroupId(null);
      setNavTab("home");
      setDeleteConfirm(null);
      showToast("Left group", "i");
    };
    setDeleteConfirm({ msg: "Leave this group? You'll lose access to the list.", action: doLeave });
  };
  const handleDeleteGroup = (groupId) => {
    const doDelete = async () => {
      await deleteGroupDB(groupId);
      setActiveGroupId(null);
      setNavTab("home");
      setDeleteConfirm(null);
      showToast("Group deleted", "r");
    };
    if (confirmDelete) setDeleteConfirm({ msg: "Delete this group? This cannot be undone.", action: doDelete });
    else doDelete();
  };

  const handleAddGroup = async () => {
    if (!newGroup.name.trim()) return;
    const { id } = await createGroup(user.uid, {
      name: newGroup.name,
      school: newGroup.school || profile.school || "",
      hall: newGroup.hall || "",
      roomType: newGroup.roomType || "",
      creatorName: profile.name || user.displayName || "You",
      
      moveInDate: newGroup.moveInDate || "",
      dormDimensions: {
        length: Number(newGroup.length) || 14,
        width: Number(newGroup.width) || 12,
      },
    });
    logActivityDB(id, `${profile.name || "You"} created this group`);
    setNewGroup({ name: "", school: "", hall: "", roomType: "", length: "", width: "", moveInDate: "" });
    setShowAddGroup(false);
    showToast("Group created!", "s");
  };

  const handleJoinGroup = async () => {
    if (!joinCode.trim()) return;
    const result = await joinGroupByCode(user.uid, profile.name || user.displayName || "Teammate", joinCode.trim(), profile.venmo || "");
    if (result.error) { showToast(result.error, "r"); return; }
    showToast("Joined group!", "s");
    setJoinCode("");
    setShowJoinGroup(false);
  };

  const handleAddEssentials = async (groupId, list) => {
    for (const e of list) {
      await addItemDB(groupId, {
        name: e.name, cost: e.cost,
        owner: null, retailer: null, purchased: false,
        shared: true, checked: false, moveOutPlan: null,
        addedBy: user.uid, addedByName: profile.name || "You",
      });
    }
    logActivityDB(groupId, `${profile.name || "You"} added ${list.length} items`);
    showToast(`${list.length} items added!`, "s");
  };

  const saveEditItem = async (groupId) => {
    await updateItem(groupId, editItem.id, { name: editItem.name, cost: Number(editItem.cost) });
    showToast("Item updated!", "s");
    setEditItem(null);
  };

  const toggleCheck = async (groupId, item) => {
    await updateItem(groupId, item.id, { checked: !item.checked });
  };
  const handleAddDeal = async () => {
    if (!newDeal.title.trim() || !newDeal.link.trim()) {
      showToast("Title and link are required", "r");
      return;
    }
    await addDeal(newDeal);
    setNewDeal({ title: "", description: "", link: "", emoji: "🔥" });
    showToast("Deal added!", "s");
  };

  const handleUpdateDeal = async () => {
    await updateDeal(editDeal.id, {
      title: editDeal.title,
      description: editDeal.description,
      link: editDeal.link,
      emoji: editDeal.emoji,
    });
    setEditDeal(null);
    showToast("Deal updated!", "s");
  };

  const handleDeleteDeal = (dealId) => {
    setDeleteConfirm({
      msg: "Delete this deal? It will be removed for all users.",
      action: async () => {
        await deleteDeal(dealId);
        setDeleteConfirm(null);
        showToast("Deal deleted", "r");
      },
    });
  };
  const handleSaveProfile = async () => {
    await saveProfile(user.uid, profile);
    showToast("Profile saved!", "s");
  };

  const addGrocery = async () => {
    if (!groceryInput.trim() || !cg) return;
    await addItemDB(cg.id, {
      name: groceryInput.trim(), cost: 0, listType: "grocery",
      owner: null, checked: false,
      addedBy: user.uid, addedByName: profile.name || "You",
    });
    logActivityDB(cg.id, `${profile.name || "You"} needs ${groceryInput.trim()}`);
    setGroceryInput("");
  };

  const generateSuggestions = () => {
    const existing = cgItems.map(i => i.name.toLowerCase());
    const picked = [];
    QUESTIONNAIRE.forEach((q, qi) => {
      const a = qAnswers[qi];
      if (a !== undefined && q.options[a]) {
        q.options[a].items.forEach(it => {
          if (!existing.includes(it.name.toLowerCase()) && !picked.some(p => p.name === it.name)) picked.push(it);
        });
      }
    });
    setQSuggestions(picked);
    setQSelected(picked.map(p => p.name));
  };

  // Settle-up math (shared items only)
  const computeSettlements = () => {
    if (!cg) return { settlements: [], balances: [] };
    const members = Object.entries(cg.memberNames || {});
    const sharedClaimed = cgItems.filter(i => i.owner && i.shared !== false);
    const totalShared = getTotal(sharedClaimed);
    const evenShare = members.length ? totalShared / members.length : 0;
    const balances = members.map(([uid, name]) => {
      const paid = getTotal(sharedClaimed.filter(i => i.owner === uid));
      return { uid, name: uid === user?.uid ? "You" : name, paid, bal: paid - evenShare };
    });
    const creditors = balances.filter(b => b.bal > 0.5).map(b => ({ ...b })).sort((a, b) => b.bal - a.bal);
    const debtors = balances.filter(b => b.bal < -0.5).map(b => ({ ...b })).sort((a, b) => a.bal - b.bal);
    const settlements = [];
    let i = 0, j = 0;
    while (i < debtors.length && j < creditors.length) {
      const amt = Math.min(-debtors[i].bal, creditors[j].bal);
      settlements.push({ from: debtors[i], to: creditors[j], amt });
      debtors[i].bal += amt;
      creditors[j].bal -= amt;
      if (debtors[i].bal > -0.5) i++;
      if (creditors[j].bal < 0.5) j++;
    }
    return { settlements, balances };
  };

  // Coverage gaps
  const coverageGaps = cg ? KEY_ESSENTIALS.filter(k =>
    !cgItems.some(i => i.name.toLowerCase().includes(k.name.toLowerCase().split(" ")[0].toLowerCase()))
  ) : [];

  // Car space
  const totalCuft = cgItems.reduce((s, i) => s + (CUBIC_FT[i.name] || 0.7), 0);
  const trunks = Math.max(1, Math.ceil(totalCuft / TRUNK_CUFT));

  const exportList = () => {
    if (!cg) return;
    const canvas = document.createElement("canvas");
    const width = 1080;
    const padding = 60;
    const headerHeight = 240;
    const itemHeight = 70;
    const footerHeight = 180;
    const height = headerHeight + (cgItems.length * itemHeight) + footerHeight;
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");

    // Background
    ctx.fillStyle = "#0a0a0a";
    ctx.fillRect(0, 0, width, height);

    // Gold gradient header bar
    const grad = ctx.createLinearGradient(0, 0, width, 0);
    grad.addColorStop(0, "#3d2e00");
    grad.addColorStop(1, "#1a1400");
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, width, 8);

    // Logo (H bracket) - drawn as rects
    const lx = padding, ly = 60, ls = 70;
    ctx.fillStyle = "#F0B323";
    // Left bracket
    ctx.fillRect(lx + 8, ly + 14, 5, 42);
    ctx.fillRect(lx + 8, ly + 14, 15, 5);
    ctx.fillRect(lx + 8, ly + 51, 15, 5);
    // Right bracket
    ctx.fillRect(lx + 57, ly + 14, 5, 42);
    ctx.fillRect(lx + 47, ly + 14, 15, 5);
    ctx.fillRect(lx + 47, ly + 51, 15, 5);
    // H
    ctx.fillRect(lx + 22, ly + 21, 5, 28);
    ctx.fillRect(lx + 43, ly + 21, 5, 28);
    ctx.fillRect(lx + 22, ly + 32, 26, 6);

    // Brand name
    ctx.fillStyle = "#F0B323";
    ctx.font = "bold 42px sans-serif";
    ctx.fillText("Haulmate", lx + 90, ly + 50);

    // Date in corner
    ctx.fillStyle = "#6a5020";
    ctx.font = "20px sans-serif";
    ctx.textAlign = "right";
    ctx.fillText(new Date().toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }), width - padding, ly + 50);
    ctx.textAlign = "left";

    // Group name
    ctx.fillStyle = "#f5f0e0";
    ctx.font = "bold 56px sans-serif";
    ctx.fillText(cg.name, padding, 200);

    // Members
    ctx.fillStyle = "#c49020";
    ctx.font = "24px sans-serif";
    const memberStr = Object.values(cg.memberNames || {}).join(" · ");
    ctx.fillText(memberStr.length > 60 ? memberStr.slice(0, 57) + "..." : memberStr, padding, 235);

    // Divider
    ctx.strokeStyle = "#2a2000";
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(padding, 275);
    ctx.lineTo(width - padding, 275);
    ctx.stroke();

    // Items
    let y = 305;
    cgItems.forEach(item => {
      // Item name
      ctx.fillStyle = "#f5f0e0";
      ctx.font = "28px sans-serif";
      const name = item.name.length > 35 ? item.name.slice(0, 32) + "..." : item.name;
      ctx.fillText(name, padding, y + 30);

      // Owner badge
      const ownerName = getDisplayName(item.owner);
      ctx.font = "20px sans-serif";
      if (ownerName) {
        ctx.fillStyle = "#4caf80";
        ctx.fillText(`✓ ${ownerName}`, padding, y + 58);
      } else {
        ctx.fillStyle = "#6a5020";
        ctx.fillText("Unclaimed", padding, y + 58);
      }

      // Price (right aligned)
      ctx.fillStyle = "#F0B323";
      ctx.font = "bold 28px sans-serif";
      ctx.textAlign = "right";
      ctx.fillText(`$${Number(item.cost).toFixed(0)}`, width - padding, y + 30);
      ctx.textAlign = "left";

      // Subtle divider
      ctx.strokeStyle = "#1a1400";
      ctx.beginPath();
      ctx.moveTo(padding, y + itemHeight);
      ctx.lineTo(width - padding, y + itemHeight);
      ctx.stroke();

      y += itemHeight;
    });

    // Total
    y += 30;
    ctx.fillStyle = "#c49020";
    ctx.font = "24px sans-serif";
    ctx.fillText("TOTAL", padding, y + 30);
    ctx.fillStyle = "#F0B323";
    ctx.font = "bold 48px sans-serif";
    ctx.textAlign = "right";
    ctx.fillText(`$${getTotal(cgItems).toFixed(0)}`, width - padding, y + 35);

    // Footer
    ctx.textAlign = "center";
    ctx.fillStyle = "#6a5020";
    ctx.font = "20px sans-serif";
    ctx.fillText("Built with Haulmate · Move smarter, together", width / 2, height - 30);

    // Convert to image and share/download
    canvas.toBlob(async (blob) => {
      if (navigator.share && navigator.canShare && navigator.canShare({ files: [new File([blob], "haulmate.png", { type: "image/png" })] })) {
        try {
          await navigator.share({
            files: [new File([blob], `${cg.name}_haulmate.png`, { type: "image/png" })],
            title: `${cg.name} Packing List`,
          });
          showToast("Shared!", "s");
        } catch (e) {
          if (e.name !== "AbortError") downloadBlob(blob, `${cg.name}_haulmate.png`);
        }
      } else {
        downloadBlob(blob, `${cg.name}_haulmate.png`);
      }
    }, "image/png");
  };

  const downloadBlob = (blob, filename) => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    a.click();
    showToast("Image saved!", "s");
  };

  const copyList = () => {
    if (!cg) return;
    const text = cgItems.map(i => `${i.name} - $${i.cost} - ${getDisplayName(i.owner) || "Unclaimed"}`).join("\n");
    navigator.clipboard?.writeText(text);
    showToast("Copied!", "s");
  };

  if (authLoading || screen === "loading") return (
    <div style={{ minHeight: "100vh", background: "#0a0a0a", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <style>{`@keyframes spin{to{transform:rotate(360deg);}}`}</style>
      <div style={{ width: 32, height: 32, border: "3px solid #2a2000", borderTopColor: "#F0B323", borderRadius: "50%", animation: "spin 0.7s linear infinite" }} />
    </div>
  );

if (!user) {
    if (previewData && !skipPreview) {
      const pg = previewData.group;
      const pItems = (previewData.items || []).filter(i => i.listType !== "grocery");
      const pTotal = pItems.reduce((s, i) => s + Number(i.cost || 0), 0);
      return (
        <div style={{ minHeight: "100vh", background: "#0a0a0a", fontFamily: "'DM Sans','Segoe UI',sans-serif", color: "#f5f0e0", display: "flex", flexDirection: "column", maxWidth: 430, margin: "0 auto", padding: "60px 24px 40px" }}>
          <style>{BASE_STYLES}</style>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 28 }}>
            <HMLogo size={40} />
            <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 20 }}>Haulmate</div>
          </div>
          <div style={{ fontSize: 12, color: "#c49020", fontWeight: 700, textTransform: "uppercase", letterSpacing: 1.5, marginBottom: 8 }}>You're invited to join</div>
          <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 28, fontWeight: 700, marginBottom: 6, letterSpacing: "-0.5px" }}>{pg.name}</div>
          <div style={{ fontSize: 14, color: "#c49020", marginBottom: 18 }}>{Object.values(pg.memberNames || {}).join(", ")}</div>
          <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
            <span className="tag tag-b">📦 {pItems.length} items</span>
            <span className="tag tag-g">💰 ${pTotal.toFixed(0)} planned</span>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 24 }}>
            {pItems.slice(0, 6).map(i => (
              <div key={i.id} style={{ display: "flex", justifyContent: "space-between", padding: "11px 14px", background: "#0a0c00", border: "1px solid #2a2000", borderRadius: 12, fontSize: 14 }}>
                <span>{i.name}</span>
                <span style={{ color: "#c49020", fontWeight: 700 }}>${i.cost}</span>
              </div>
            ))}
            {pItems.length > 6 && <div style={{ fontSize: 13, color: "#6a5020", textAlign: "center" }}>+ {pItems.length - 6} more items</div>}
            {pItems.length === 0 && <div style={{ fontSize: 13, color: "#6a5020", textAlign: "center", padding: 12 }}>No items yet — be the first to add some!</div>}
          </div>
          <button className="btn-p" onClick={() => setSkipPreview(true)}>Sign in to join this group</button>
        </div>
      );
    }
    return <Login />;
  }

  if (screen === "onboard1") return (
    <div style={{ minHeight: "100vh", background: "#0a0a0a", fontFamily: "'DM Sans','Segoe UI',sans-serif", color: "#f5f0e0", display: "flex", flexDirection: "column", maxWidth: 430, margin: "0 auto" }}>
      <style>{BASE_STYLES}</style>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 32px", gap: 32, textAlign: "center" }}>
        <HMLogo size={72} />
        <div>
          <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 32, fontWeight: 700, letterSpacing: "-1px", marginBottom: 12 }}>Welcome to Haulmate</div>
          <div style={{ fontSize: 16, color: "#c49020", lineHeight: 1.6 }}>Coordinate your dorm move-in with your roommates — no duplicates, no stress.</div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          {[0,1,2].map(i => <div key={i} style={{ width: i === 0 ? 24 : 8, height: 8, borderRadius: 4, background: i === 0 ? "#F0B323" : "#2a2000" }} />)}
        </div>
        <button className="btn-p" onClick={() => setScreen("onboard2")}>Get Started</button>
      </div>
    </div>
  );

  if (screen === "onboard2") return (
    <div style={{ minHeight: "100vh", background: "#0a0a0a", fontFamily: "'DM Sans','Segoe UI',sans-serif", color: "#f5f0e0", display: "flex", flexDirection: "column", maxWidth: 430, margin: "0 auto" }}>
      <style>{BASE_STYLES}</style>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: "60px 32px 40px", gap: 28 }}>
        <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
          {[0,1,2].map(i => <div key={i} style={{ width: i === 1 ? 24 : 8, height: 8, borderRadius: 4, background: i === 1 ? "#F0B323" : "#2a2000" }} />)}
        </div>
        <div>
          <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 26, fontWeight: 700, marginBottom: 8 }}>Your Profile</div>
          <div style={{ fontSize: 14, color: "#c49020" }}>Tell us a bit about yourself</div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <div style={{ fontSize: 13, color: "#c49020", marginBottom: 8, fontWeight: 600 }}>YOUR NAME</div>
            <input className="inp" placeholder="e.g. Joshua" value={profile.name} onChange={e => setProfile(p => ({ ...p, name: e.target.value }))} />
          </div>
          <div>
            <div style={{ fontSize: 13, color: "#c49020", marginBottom: 8, fontWeight: 600 }}>YOUR SCHOOL</div>
            <select className="inp" value={profile.school} onChange={e => setProfile(p => ({ ...p, school: e.target.value }))}>
              <option value="">Select your school...</option>
              {SCHOOLS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
            </select>
          </div>
         
        </div>
        <div style={{ flex: 1 }} />
        <button className="btn-p" disabled={!profile.name} onClick={async () => { await saveProfile(user.uid, profile); setScreen("onboard3"); }} style={{ opacity: !profile.name ? 0.4 : 1 }}>Continue</button>
        <button className="btn-g" onClick={() => setScreen("onboard3")}>Skip for now</button>
      </div>
    </div>
  );

  if (screen === "onboard3") return (
    <div style={{ minHeight: "100vh", background: "#0a0a0a", fontFamily: "'DM Sans','Segoe UI',sans-serif", color: "#f5f0e0", display: "flex", flexDirection: "column", maxWidth: 430, margin: "0 auto" }}>
      <style>{BASE_STYLES}</style>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", padding: "60px 32px 40px", gap: 20, textAlign: "center" }}>
        <div style={{ display: "flex", gap: 8 }}>
          {[0,1,2].map(i => <div key={i} style={{ width: i === 2 ? 24 : 8, height: 8, borderRadius: 4, background: i === 2 ? "#F0B323" : "#2a2000" }} />)}
        </div>
        <div style={{ fontSize: 48 }}>📦</div>
        <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 26, fontWeight: 700 }}>Here's how it works</div>
        {[
          { icon: "👥", title: "Create a group", desc: "Add your roommates and set your dorm dimensions" },
          { icon: "📋", title: "Add items", desc: "Build your packing list and see who's bringing what" },
          { icon: "⚠️", title: "Avoid duplicates", desc: "We flag conflicts so nobody brings two fridges" },
          { icon: "🛒", title: "Shop your cart", desc: "Claim items, pick a store, and buy from your cart tab" },
        ].map((s, i) => (
          <div key={i} style={{ display: "flex", gap: 14, alignItems: "flex-start", textAlign: "left", background: "#0d0e00", border: "1px solid #2a2000", borderRadius: 14, padding: "14px 16px", width: "100%" }}>
            <span style={{ fontSize: 22, flexShrink: 0 }}>{s.icon}</span>
            <div>
              <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 3 }}>{s.title}</div>
              <div style={{ fontSize: 13, color: "#c49020" }}>{s.desc}</div>
            </div>
          </div>
        ))}
        <button className="btn-p" style={{ width: "100%", marginTop: 8 }} onClick={() => { localStorage.setItem("haulmate_onboarded", "true"); setScreen("home"); }}>Let's go</button>
      </div>
    </div>
  );

  const { settlements } = computeSettlements();
  const moveInDays = daysUntilMoveIn(cg);

  return (
    <div style={{ minHeight: "100vh", background: "#0a0a0a", fontFamily: "'DM Sans','Segoe UI',sans-serif", color: "#f5f0e0", display: "flex", flexDirection: "column", maxWidth: 430, margin: "0 auto", position: "relative" }}>
      <style>{BASE_STYLES}</style>
      {toast && <div className={`toast t${toast.type}`}>{toast.msg}</div>}

      {/* CONFIRM DELETE */}
      {deleteConfirm && (
        <div className="modal-center">
          <div className="modal-box">
            <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 18, textAlign: "center" }}>Are you sure?</div>
            <div style={{ fontSize: 14, color: "#c49020", textAlign: "center" }}>{deleteConfirm.msg}</div>
            <button className="btn-danger" onClick={deleteConfirm.action}>Yes, delete</button>
            <button className="btn-g" onClick={() => setDeleteConfirm(null)}>Cancel</button>
          </div>
        </div>
      )}

      {/* SPACE WARNING */}
      {spaceWarn && (
        <div className="modal-center">
          <div className="modal-box">
            <div style={{ fontSize: 28, textAlign: "center" }}>📐</div>
            <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 18, textAlign: "center" }}>Space Warning</div>
            <div style={{ fontSize: 14, color: "#e0a050", textAlign: "center", lineHeight: 1.6 }}>{spaceWarn.note}</div>
            <button className="btn-p" onClick={() => { spaceWarn.proceed(); setSpaceWarn(null); }}>Add Anyway</button>
            <button className="btn-g" onClick={() => setSpaceWarn(null)}>Cancel</button>
          </div>
        </div>
      )}

      {/* BANNED WARNING */}
      {bannedWarn && (
        <div className="modal-center">
          <div className="modal-box">
            <div style={{ fontSize: 28, textAlign: "center" }}>🚫</div>
            <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 18, textAlign: "center" }}>Commonly Banned Item</div>
            <div style={{ fontSize: 14, color: "#e07070", textAlign: "center", lineHeight: 1.6 }}>{bannedWarn.name} is commonly prohibited in dorms. Check your school's policy before bringing it.</div>
            <button className="btn-p" onClick={() => { bannedWarn.proceed(); setBannedWarn(null); }}>Add Anyway</button>
            <button className="btn-g" onClick={() => setBannedWarn(null)}>Cancel</button>
          </div>
        </div>
      )}



      {/* BOUGHT CONFIRMATION */}
      {boughtModal && (
        <div className="modal-center" onClick={() => setBoughtModal(null)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 18, textAlign: "center" }}>Bought it! 🎉</div>
            <div style={{ fontSize: 14, color: "#c49020", textAlign: "center" }}>How much did {boughtModal.item.name} actually cost?</div>
            <input className="inp" type="number" value={boughtModal.price} onChange={e => setBoughtModal(p => ({ ...p, price: e.target.value }))} placeholder="Actual price ($)" />
            <button className="btn-p" onClick={confirmBought}>Confirm</button>
            <button className="btn-g" onClick={() => setBoughtModal(null)}>Cancel</button>
          </div>
        </div>
      )}
      {/* ADMIN PANEL */}
      {showAdminPanel && user?.uid === ADMIN_UID && (
        <div className="modal-bg" onClick={() => setShowAdminPanel(false)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 18 }}>🛠️ Admin Panel</div>
              <button onClick={() => setShowAdminPanel(false)} style={{ background: "none", border: "none", color: "#6a5020", fontSize: 20, cursor: "pointer" }}>x</button>
            </div>
            <div style={{ fontSize: 13, color: "#c49020" }}>Manage featured deals shown on home screen</div>

            <div style={{ background: "#0a0c00", border: "1px solid #2a2000", borderRadius: 12, padding: 14 }}>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 14, marginBottom: 10 }}>Add New Deal</div>
              <input className="inp" style={{ marginBottom: 8 }} placeholder="Emoji (e.g. 🔥)" value={newDeal.emoji} onChange={e => setNewDeal(p => ({ ...p, emoji: e.target.value }))} maxLength={2} />
              <input className="inp" style={{ marginBottom: 8 }} placeholder="Title (e.g. 30% off mini fridges)" value={newDeal.title} onChange={e => setNewDeal(p => ({ ...p, title: e.target.value }))} />
              <input className="inp" style={{ marginBottom: 8 }} placeholder="Description (optional)" value={newDeal.description} onChange={e => setNewDeal(p => ({ ...p, description: e.target.value }))} />
              <input className="inp" style={{ marginBottom: 8 }} placeholder="Amazon link (with affiliate tag)" value={newDeal.link} onChange={e => setNewDeal(p => ({ ...p, link: e.target.value }))} />
              <button className="btn-p" onClick={handleAddDeal}>+ Add Deal</button>
            </div>

            <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 14, marginTop: 8 }}>Active Deals ({deals.length})</div>
            {deals.length === 0 && <div style={{ fontSize: 13, color: "#6a5020", textAlign: "center", padding: 12 }}>No deals yet</div>}
            {deals.map(deal => (
              <div key={deal.id} style={{ background: "#0a0c00", border: "1px solid #2a2000", borderRadius: 12, padding: 12, display: "flex", gap: 10, alignItems: "center" }}>
                <span style={{ fontSize: 22 }}>{deal.emoji}</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 700 }}>{deal.title}</div>
                  {deal.description && <div style={{ fontSize: 12, color: "#c49020" }}>{deal.description}</div>}
                </div>
                <button onClick={() => setEditDeal({ ...deal })} style={{ background: "#0d0e00", border: "1px solid #242010", borderRadius: 8, padding: "5px 10px", cursor: "pointer", color: "#c49020", fontSize: 11, fontWeight: 700 }}>Edit</button>
                <button onClick={() => handleDeleteDeal(deal.id)} style={{ background: "#1a0808", border: "1px solid #4a1a1a", borderRadius: 8, padding: "5px 10px", cursor: "pointer", color: "#e07070", fontSize: 11, fontWeight: 700 }}>Del</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* EDIT DEAL */}
      {editDeal && (
        <div className="modal-bg" onClick={() => setEditDeal(null)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 18 }}>Edit Deal</div>
              <button onClick={() => setEditDeal(null)} style={{ background: "none", border: "none", color: "#6a5020", fontSize: 20, cursor: "pointer" }}>x</button>
            </div>
            <input className="inp" placeholder="Emoji" value={editDeal.emoji || ""} onChange={e => setEditDeal(p => ({ ...p, emoji: e.target.value }))} maxLength={2} />
            <input className="inp" placeholder="Title" value={editDeal.title || ""} onChange={e => setEditDeal(p => ({ ...p, title: e.target.value }))} />
            <input className="inp" placeholder="Description" value={editDeal.description || ""} onChange={e => setEditDeal(p => ({ ...p, description: e.target.value }))} />
            <input className="inp" placeholder="Amazon link" value={editDeal.link || ""} onChange={e => setEditDeal(p => ({ ...p, link: e.target.value }))} />
            <button className="btn-p" onClick={handleUpdateDeal}>Save Changes</button>
          </div>
        </div>
      )}
      {/* EDIT ITEM */}
      {editItem && (
        <div className="modal-bg" onClick={() => setEditItem(null)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 18 }}>Edit Item</div>
              <button onClick={() => setEditItem(null)} style={{ background: "none", border: "none", color: "#6a5020", fontSize: 20, cursor: "pointer" }}>x</button>
            </div>
            <input className="inp" value={editItem.name} onChange={e => setEditItem(p => ({ ...p, name: e.target.value }))} />
            <input className="inp" type="number" value={editItem.cost} placeholder="Cost ($)" onChange={e => setEditItem(p => ({ ...p, cost: e.target.value }))} />
            <button className="btn-p" onClick={() => saveEditItem(activeGroupId)}>Save Changes</button>
            <button className="btn-danger" onClick={() => handleDeleteItem(activeGroupId, editItem)}>Delete Item</button>
          </div>
        </div>
      )}

      {/* ADD ITEM */}
      {showAddItem && (
        <div className="modal-bg" onClick={() => setShowAddItem(false)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 18 }}>Add Item</div>
              <button onClick={() => setShowAddItem(false)} style={{ background: "none", border: "none", color: "#6a5020", fontSize: 20, cursor: "pointer" }}>x</button>
            </div>
            <input className="inp" placeholder="Item name" value={newItem.name} onChange={e => setNewItem(p => ({ ...p, name: e.target.value }))} />
            <input className="inp" type="number" placeholder="Estimated cost ($)" value={newItem.cost} onChange={e => setNewItem(p => ({ ...p, cost: e.target.value }))} />
            <div style={{ display: "flex", gap: 8 }}>
              <button className={`chip ${newItem.shared ? "sel" : ""}`} onClick={() => setNewItem(p => ({ ...p, shared: true }))}>Shared (group splits)</button>
              <button className={`chip ${!newItem.shared ? "sel" : ""}`} onClick={() => setNewItem(p => ({ ...p, shared: false }))}>Personal</button>
            </div>
            <button className="btn-p" onClick={() => handleAddItem(activeGroupId)}>Add to List</button>
            <button className="btn-g" onClick={() => { setShowAddItem(false); setShowEssentials(true); }}>Browse Essentials Instead</button>
          </div>
        </div>
      )}

      {/* ADD GROUP */}
      {showAddGroup && (
        <div className="modal-bg" onClick={() => setShowAddGroup(false)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 18 }}>Create Group</div>
              <button onClick={() => setShowAddGroup(false)} style={{ background: "none", border: "none", color: "#6a5020", fontSize: 20, cursor: "pointer" }}>x</button>
            </div>
            <input className="inp" placeholder="Group name (e.g. UMBC Fall 2026)" value={newGroup.name} onChange={e => setNewGroup(p => ({ ...p, name: e.target.value }))} />
            <div style={{ fontSize: 13, color: "#c49020" }}>Move-in date (optional)</div>
            <input className="inp" type="date" value={newGroup.moveInDate} onChange={e => setNewGroup(p => ({ ...p, moveInDate: e.target.value }))} style={{ minHeight: 48, colorScheme: "dark" }} />
            <div style={{ fontSize: 13, color: "#c49020" }}>Which school?</div>
            <div style={{ display: "flex", gap: 8 }}>
              <button className={`chip ${newGroup.school === "UMBC" ? "sel" : ""}`} style={{ flex: 1, justifyContent: "center" }} onClick={() => setNewGroup(p => ({ ...p, school: "UMBC", hall: "", length: "", width: "" }))}>UMBC</button>
              <button className={`chip ${newGroup.school === "UMD" ? "sel" : ""}`} style={{ flex: 1, justifyContent: "center" }} onClick={() => setNewGroup(p => ({ ...p, school: "UMD", hall: "", length: "", width: "" }))}>UMD</button>
            </div>
            {newGroup.school && (
              <>
                <div style={{ fontSize: 13, color: "#c49020" }}>Residence hall (auto-fills room size)</div>
                <select className="inp" value={newGroup.hall} onChange={e => {
                  const h = DORM_PRESETS[newGroup.school].find(x => x.name === e.target.value);
                  if (h) {
                    const keys = Object.keys(h.types);
                    if (keys.length === 1) {
                      const d = h.types[keys[0]];
                      setNewGroup(p => ({ ...p, hall: e.target.value, roomType: keys[0], length: String(d.length), width: String(d.width) }));
                    } else {
                      setNewGroup(p => ({ ...p, hall: e.target.value, roomType: "", length: "", width: "" }));
                    }
                  } else {
                    setNewGroup(p => ({ ...p, hall: "", roomType: "", length: "", width: "" }));
                  }
                }}>
                  <option value="">Pick your hall (optional)</option>
                  {DORM_PRESETS[newGroup.school].map(h => <option key={h.name} value={h.name}>{h.name}</option>)}
                </select>
                {(() => {
                  const h = DORM_PRESETS[newGroup.school].find(x => x.name === newGroup.hall);
                  if (!h) return null;
                  const keys = Object.keys(h.types);
                  return (
                    <>
                      {keys.length > 1 && (
                        <>
                          <div style={{ fontSize: 13, color: "#c49020" }}>What room are you in?</div>
                          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                            {keys.map(t => (
                              <button key={t} className={`chip ${newGroup.roomType === t ? "sel" : ""}`} onClick={() => { const d = h.types[t]; setNewGroup(p => ({ ...p, roomType: t, length: String(d.length), width: String(d.width) })); }}>{t} ({h.types[t].width}x{h.types[t].length})</button>
                            ))}
                          </div>
                        </>
                      )}
                      {h.note && <div style={{ fontSize: 12, color: "#6a5020" }}>* {h.note}</div>}
                      {h.estimated && <div style={{ fontSize: 12, color: "#6a5020" }}>* Estimated — UMD doesn't publish official sizes. Edit below if you know yours.</div>}
                    </>
                  );
                })()}
              </>
            )}
            <div style={{ fontSize: 13, color: "#c49020" }}>Dorm dimensions (approx — edit if needed)</div>
            <div style={{ display: "flex", gap: 10 }}>
              <input className="inp" type="number" placeholder="Length (ft)" value={newGroup.length} onChange={e => setNewGroup(p => ({ ...p, length: e.target.value }))} />
              <input className="inp" type="number" placeholder="Width (ft)" value={newGroup.width} onChange={e => setNewGroup(p => ({ ...p, width: e.target.value }))} />
            </div>
            <button className="btn-p" onClick={handleAddGroup}>Create Group</button>
            <button className="btn-g" onClick={() => { setShowAddGroup(false); setShowJoinGroup(true); }}>Join Existing Group Instead</button>
          </div>
        </div>
      )}

      {/* JOIN GROUP */}
      {showJoinGroup && (
        <div className="modal-bg" onClick={() => setShowJoinGroup(false)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 18 }}>Join a Group</div>
              <button onClick={() => setShowJoinGroup(false)} style={{ background: "none", border: "none", color: "#6a5020", fontSize: 20, cursor: "pointer" }}>x</button>
            </div>
            <div style={{ fontSize: 14, color: "#c49020" }}>Enter the invite code your roommate shared</div>
            <input className="inp" placeholder="e.g. HM-X4K9PZ" value={joinCode} onChange={e => setJoinCode(e.target.value.toUpperCase())} style={{ letterSpacing: 3, fontFamily: "'Space Grotesk',sans-serif", fontSize: 18, fontWeight: 700 }} />
            <button className="btn-p" onClick={handleJoinGroup}>Join Group</button>
          </div>
        </div>
      )}

      {/* ESSENTIALS */}
      {showEssentials && cg && (
        <div className="modal-bg" onClick={() => setShowEssentials(false)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 18 }}>Dorm Essentials</div>
              <button onClick={() => setShowEssentials(false)} style={{ background: "none", border: "none", color: "#6a5020", fontSize: 20, cursor: "pointer" }}>x</button>
            </div>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              {Object.keys(ESSENTIALS).map(cat => (
                <button key={cat} className={`chip ${essentialCat === cat ? "sel" : ""}`} onClick={() => setEssentialCat(cat)}>{cat}</button>
              ))}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, maxHeight: 280, overflowY: "auto" }}>
              {ESSENTIALS[essentialCat].map((item, i) => {
                const sel = selectedEssentials.some(e => e.name === item.name);
                return (
                  <div key={i} onClick={() => setSelectedEssentials(s => sel ? s.filter(e => e.name !== item.name) : [...s, item])} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "11px 14px", background: sel ? "#1a1400" : "#0a0c00", border: `1px solid ${sel ? "#F0B323" : "#2a2000"}`, borderRadius: 12, cursor: "pointer" }}>
                    <div style={{ fontSize: 14, fontWeight: 500 }}>{item.name}</div>
                    <span style={{ fontSize: 13, color: "#c49020", fontWeight: 700 }}>${item.cost}</span>
                  </div>
                );
              })}
            </div>
            {selectedEssentials.length > 0 && (
              <button className="btn-p" onClick={async () => { await handleAddEssentials(cg.id, selectedEssentials); setSelectedEssentials([]); setShowEssentials(false); }}>
                Add {selectedEssentials.length} Item{selectedEssentials.length !== 1 ? "s" : ""} — ${selectedEssentials.reduce((s, e) => s + e.cost, 0).toFixed(0)}
              </button>
            )}
          </div>
        </div>
      )}

      {/* QUESTIONNAIRE */}
      {showQuestionnaire && cg && (
        <div className="modal-bg" onClick={() => { setShowQuestionnaire(false); setQSuggestions(null); setQAnswers({}); }}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 18 }}>Smart Starter List</div>
              <button onClick={() => { setShowQuestionnaire(false); setQSuggestions(null); setQAnswers({}); }} style={{ background: "none", border: "none", color: "#6a5020", fontSize: 20, cursor: "pointer" }}>x</button>
            </div>
            {!qSuggestions ? (
              <>
                <div style={{ fontSize: 13, color: "#c49020" }}>Answer a few questions and we'll build you a starting list.</div>
                {QUESTIONNAIRE.map((q, qi) => (
                  <div key={qi}>
                    <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 8 }}>{q.q}</div>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      {q.options.map((o, oi) => (
                        <button key={oi} className={`chip ${qAnswers[qi] === oi ? "sel" : ""}`} onClick={() => setQAnswers(a => ({ ...a, [qi]: oi }))}>{o.label}</button>
                      ))}
                    </div>
                  </div>
                ))}
                <button className="btn-p" disabled={Object.keys(qAnswers).length < QUESTIONNAIRE.length} style={{ opacity: Object.keys(qAnswers).length < QUESTIONNAIRE.length ? 0.4 : 1 }} onClick={generateSuggestions}>Generate My List</button>
              </>
            ) : (
              <>
                <div style={{ fontSize: 13, color: "#c49020" }}>{qSuggestions.length ? "Based on your answers, you should bring:" : "Your group already covers everything we'd suggest!"}</div>
                {qSuggestions.map((s, i) => {
                  const sel = qSelected.includes(s.name);
                  return (
                    <div key={i} onClick={() => setQSelected(q => sel ? q.filter(n => n !== s.name) : [...q, s.name])} style={{ display: "flex", justifyContent: "space-between", padding: "11px 14px", background: sel ? "#1a1400" : "#0a0c00", border: `1px solid ${sel ? "#F0B323" : "#2a2000"}`, borderRadius: 12, cursor: "pointer" }}>
                      <span style={{ fontSize: 14, fontWeight: 500 }}>{s.name}</span>
                      <span style={{ fontSize: 13, color: "#c49020", fontWeight: 700 }}>${s.cost}</span>
                    </div>
                  );
                })}
                {qSelected.length > 0 && (
                  <button className="btn-p" onClick={async () => {
                    await handleAddEssentials(cg.id, qSuggestions.filter(s => qSelected.includes(s.name)));
                    setShowQuestionnaire(false); setQSuggestions(null); setQAnswers({}); setQSelected([]);
                  }}>Add {qSelected.length} to Group List</button>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {/* MOVE-OUT PLANNER */}
      {showMoveOut && cg && (
        <div className="modal-bg" onClick={() => setShowMoveOut(false)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 18 }}>Move-Out Planner</div>
              <button onClick={() => setShowMoveOut(false)} style={{ background: "none", border: "none", color: "#6a5020", fontSize: 20, cursor: "pointer" }}>x</button>
            </div>
            <div style={{ fontSize: 13, color: "#c49020" }}>Decide what happens to each item at the end of the year.</div>
            {cgItems.map(item => (
              <div key={item.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", background: "#0a0c00", border: "1px solid #2a2000", borderRadius: 12 }}>
                <div style={{ flex: 1, fontSize: 14, fontWeight: 600 }}>{item.name}</div>
                <select className="inp" style={{ width: 140, padding: "8px 10px", fontSize: 12 }} value={item.moveOutPlan || ""} onChange={e => updateItem(cg.id, item.id, { moveOutPlan: e.target.value || null })}>
                  <option value="">No plan</option>
                  {MOVEOUT_PLANS.map(p => <option key={p} value={p}>{p}</option>)}
                </select>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* MOVE-IN DAY MODE */}
      {showMoveInMode && cg && (
        <div className="modal-bg" onClick={() => setShowMoveInMode(false)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 18 }}>🚚 Move-In Day Mode</div>
              <button onClick={() => setShowMoveInMode(false)} style={{ background: "none", border: "none", color: "#6a5020", fontSize: 20, cursor: "pointer" }}>x</button>
            </div>
            <div style={{ background: "#1a1400", border: "1px solid #3d2e00", borderRadius: 14, padding: 14, textAlign: "center" }}>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 24, fontWeight: 700, color: "#F0B323" }}>{cgItems.filter(i => i.checked).length}/{cgItems.length}</div>
              <div style={{ fontSize: 12, color: "#c49020" }}>items packed</div>
            </div>
            {cgItems.filter(i => !i.checked).length > 0 && (
              <>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#e0a050" }}>Still not packed:</div>
                {cgItems.filter(i => !i.checked).map(i => (
                  <div key={i.id} onClick={() => toggleCheck(cg.id, i)} style={{ display: "flex", justifyContent: "space-between", padding: "10px 14px", background: "#0a0c00", border: "1px solid #2a2000", borderRadius: 12, cursor: "pointer", fontSize: 14 }}>
                    <span>{i.name}</span>
                    <span style={{ color: "#6a5020", fontSize: 12 }}>{getDisplayName(i.owner) || "Unclaimed"}</span>
                  </div>
                ))}
              </>
            )}
            <div style={{ fontSize: 13, fontWeight: 700, color: "#F0B323", marginTop: 6 }}>Last sweep — don't forget:</div>
            {LAST_SWEEP.map((s, i) => (
              <div key={i} onClick={() => setLastSweepDone(d => ({ ...d, [i]: !d[i] }))} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: "#0a0c00", border: "1px solid #2a2000", borderRadius: 12, cursor: "pointer", opacity: lastSweepDone[i] ? 0.45 : 1 }}>
                <div style={{ width: 18, height: 18, borderRadius: 5, border: `2px solid ${lastSweepDone[i] ? "#F0B323" : "#4a3800"}`, background: lastSweepDone[i] ? "#3d2e00" : "transparent", flexShrink: 0 }} />
                <span style={{ fontSize: 14, textDecoration: lastSweepDone[i] ? "line-through" : "none" }}>{s}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* HOME */}
      {navTab === "home" && (
        <div style={{ flex: 1, overflowY: "auto", paddingBottom: 80 }}>
          <div style={{ padding: "52px 24px 20px", background: "linear-gradient(180deg,#0d0c00 0%,#0a0a0a 100%)" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <HMLogo size={38} />
                <div>
                  <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 20, letterSpacing: "-0.5px" }}>Haulmate</div>
                  <div style={{ fontSize: 12, color: "#6a5020", fontWeight: 500 }}>Move smarter, together</div>
                </div>
              </div>
              <div onClick={() => setNavTab("profile")} style={{ width: 38, height: 38, borderRadius: "50%", background: "linear-gradient(135deg,#3d2e00,#1a1400)", border: "1px solid #8a6200", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, cursor: "pointer", color: "#F0B323" }}>
                {profile.name ? profile.name[0].toUpperCase() : "?"}
              </div>
            </div>
            <div style={{ background: "linear-gradient(135deg,#1a1400,#0f0d00)", border: "1px solid #3d2e00", borderRadius: 20, padding: "20px 22px" }}>
              {profile.name && <div style={{ fontSize: 13, color: "#8a7030", marginBottom: 4 }}>Hey {profile.name}</div>}
              <div style={{ fontSize: 13, color: "#c49020", fontWeight: 600, marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.8px" }}>Total Haul</div>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 36, fontWeight: 700, letterSpacing: "-1px" }}>
                ${groups.reduce((s, g) => s + getTotal((groupItems[g.id] || []).filter(i => i.listType !== "grocery" && i.owner === user?.uid)), 0).toFixed(0)}
              </div>
              <div style={{ fontSize: 13, color: "#6a5020", marginTop: 4 }}>{groups.length} group{groups.length !== 1 ? "s" : ""} · {cartUnbought > 0 ? `${cartUnbought} items left to buy` : "cart all bought"}</div>
            </div>
          </div>

          <div style={{ padding: "16px 24px", display: "flex", flexDirection: "column", gap: 14 }}>
            {deals.length > 0 && (
              <div style={{ marginBottom: 4 }}>
                <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 18, fontWeight: 700, marginBottom: 10 }}>🔥 Featured Deals</div>
                <div style={{ display: "flex", gap: 10, overflowX: "auto", paddingBottom: 8, marginBottom: 14 }}>
                  {deals.map(deal => (
                    <a key={deal.id} href={deal.link} target="_blank" rel="noopener noreferrer" style={{ flex: "0 0 240px", background: "linear-gradient(135deg, #1a1400, #0f0d00)", border: "1px solid #3d2e00", borderRadius: 16, padding: "14px 16px", textDecoration: "none", color: "#f5f0e0", display: "flex", flexDirection: "column", gap: 4 }}>
                      <div style={{ fontSize: 24 }}>{deal.emoji}</div>
                      <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 14 }}>{deal.title}</div>
                      {deal.description && <div style={{ fontSize: 12, color: "#c49020" }}>{deal.description}</div>}
                      <div style={{ fontSize: 12, color: "#F0B323", fontWeight: 700, marginTop: 6 }}>Shop on Amazon →</div>
                    </a>
                  ))}
                </div>
              </div>
            )}
            <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 18, fontWeight: 700 }}>My Groups</div>
            {groups.length === 0 && (
              <div style={{ textAlign: "center", padding: 24, color: "#6a5020", fontSize: 14 }}>No groups yet — create one or join a roommate's group</div>
            )}
            {groups.map(group => {
              const items = (groupItems[group.id] || []).filter(i => i.listType !== "grocery");
              const dp = getDupes(items);
              const checked = items.filter(i => i.checked).length;
              const pct = items.length ? (checked / items.length) * 100 : 0;
              const days = daysUntilMoveIn(group);
              return (
                <div key={group.id} className="card" style={{ cursor: "pointer" }} onClick={() => { setActiveGroupId(group.id); setActiveTab("list"); setNavTab("group"); setSearchQ(""); }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 3, fontFamily: "'Space Grotesk',sans-serif" }}>{group.name}</div>
                      <div style={{ fontSize: 13, color: "#6a5020" }}>{Object.values(group.memberNames || {}).join(", ")}</div>
                    </div>
                    <svg width={42} height={42} className="prog-ring">
                      <circle cx={21} cy={21} r={17} fill="none" stroke="#0d0e00" strokeWidth={4}/>
                      <circle cx={21} cy={21} r={17} fill="none" stroke="#F0B323" strokeWidth={4} strokeDasharray={`${(pct/100)*107} 107`} strokeLinecap="round"/>
                    </svg>
                  </div>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
                    <span className="tag tag-b">📦 {items.length} items</span>
                    <span className="tag tag-g">💰 ${getTotal(items).toFixed(0)}</span>
                    {Object.keys(group.memberNames || {}).length === 1 && <span className="tag tag-gray">Solo</span>}
                    {days !== null && days >= 0 && <span className="tag tag-y">🚚 {days === 0 ? "Move-in TODAY" : `${days} days out`}</span>}
                    {dp.length > 0 && <span className="tag tag-r">⚠️ {dp.length} conflict{dp.length > 1 ? "s" : ""}</span>}
                  </div>
                  <div className="pbar"><div className="pfill" style={{ width: `${pct}%` }} /></div>
                  <div style={{ fontSize: 12, color: "#6a5020", marginTop: 5 }}>{checked}/{items.length} packed</div>
                </div>
              );
            })}
            <button className="btn-p" onClick={() => setShowAddGroup(true)}>+ Create New Group</button>
            <button className="btn-g" onClick={() => setShowJoinGroup(true)}>Join a Group</button>
          </div>
        </div>
      )}

      {/* CART */}
      {navTab === "cart" && (
        <div style={{ flex: 1, overflowY: "auto", paddingBottom: 80 }}>
          <div style={{ padding: "52px 24px 16px" }}>
            <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 22, fontWeight: 700, marginBottom: 6 }}>My Cart</div>
            <div style={{ fontSize: 13, color: "#c49020", marginBottom: 16 }}>
              {myCart.length === 0 ? "Claim items in your groups to build your cart" : cartUnbought > 0 ? `${cartUnbought} item${cartUnbought !== 1 ? "s" : ""} left to buy · $${getTotal(myCart.filter(i => !i.purchased)).toFixed(0)} remaining` : "Everything bought! 🎉"}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {myCart.map(item => (
                <div key={item.id} className="row" style={{ opacity: item.purchased ? 0.5 : 1 }}>
                  <div onClick={() => handleBoughtTap(item.groupId, item)} style={{ width: 22, height: 22, borderRadius: 6, border: `2px solid ${item.purchased ? "#F0B323" : "#4a3800"}`, background: item.purchased ? "#3d2e00" : "transparent", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, cursor: "pointer" }}>
                    {item.purchased && <span style={{ fontSize: 12, color: "#F0B323" }}>✓</span>}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 15, fontWeight: 600, textDecoration: item.purchased ? "line-through" : "none" }}>{item.name}</div>
                    <div style={{ fontSize: 12, color: "#6a5020" }}>${item.cost}{item.purchased ? "" : " est."} · {item.groupName}</div>
                  </div>
                  <a href={amazonLink(item.name)} target="_blank" rel="noopener noreferrer" style={{ background: "linear-gradient(135deg, #3d2e00, #1a1400)", border: "1px solid #8a6200", borderRadius: 10, padding: "10px 20px", color: "#F0B323", fontSize: 14, fontWeight: 700, textDecoration: "none", flexShrink: 0 }}>Buy on Amazon</a>
                </div>
              ))}
            </div>
            
                
            {myCart.length === 0 && (
              <div style={{ textAlign: "center", padding: 40, color: "#6a5020", fontSize: 14 }}>🛒<br /><br />Your cart is empty.<br />Claim items in a group and they'll show up here.</div>
            )}
          </div>
        </div>
      )}

      {/* GROUP DETAIL */}
      {navTab === "group" && cg && (
        <div style={{ flex: 1, overflowY: "auto", paddingBottom: 80 }}>
          <div style={{ padding: "52px 24px 16px", background: "linear-gradient(180deg,#0d0c00 0%,#0a0a0a 100%)" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
              <button onClick={() => setNavTab("home")} style={{ background: "#0d0e00", border: "1px solid #2a2000", borderRadius: 10, color: "#d4a830", padding: "8px 12px", cursor: "pointer", fontSize: 14, fontWeight: 600 }}>Back</button>
              <div style={{ flex: 1 }}>
                <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 17 }}>{cg.name}</div>
                <div style={{ fontSize: 12, color: "#6a5020" }}>{Object.values(cg.memberNames || {}).join(" · ")}</div>
              </div>
              {cg.createdBy === user?.uid ? (
                <button onClick={() => handleDeleteGroup(cg.id)} style={{ background: "#1a0808", border: "1px solid #4a1a1a", borderRadius: 10, color: "#e07070", padding: "8px 10px", cursor: "pointer", fontSize: 12, fontWeight: 600 }}>Delete</button>
              ) : (
                <button onClick={() => handleLeaveGroup(cg.id)} style={{ background: "#1a0808", border: "1px solid #4a1a1a", borderRadius: 10, color: "#e07070", padding: "8px 10px", cursor: "pointer", fontSize: 12, fontWeight: 600 }}>Leave</button>
              )}
            </div>
            {moveInDays !== null && moveInDays >= 0 && (
              <div onClick={() => setShowMoveInMode(true)} style={{ background: moveInDays <= 3 ? "#2a1a08" : "#1a1400", border: `1px solid ${moveInDays <= 3 ? "#e0a050" : "#3d2e00"}`, borderRadius: 12, padding: "10px 14px", marginBottom: 10, fontSize: 13, color: moveInDays <= 3 ? "#e0a050" : "#F0B323", fontWeight: 700, cursor: "pointer", display: "flex", justifyContent: "space-between" }}>
                <span>🚚 {moveInDays === 0 ? "MOVE-IN DAY IS TODAY!" : `${moveInDays} days until move-in`}</span>
                <span>Open Move-In Mode →</span>
              </div>
            )}
            {Object.keys(cg.memberNames || {}).length === 1 && (
              <div style={{ background: "#1a1400", border: "1px solid #3d2e00", borderRadius: 12, padding: "12px 14px", marginBottom: 10 }}>
                <div style={{ fontSize: 13, color: "#F0B323", fontWeight: 700, marginBottom: 4 }}>Flying solo for now 🦅</div>
                <div style={{ fontSize: 12, color: "#c49020", marginBottom: 10, lineHeight: 1.5 }}>Build your list — conflict detection and cost splitting light up automatically when your roommate joins with code <b>{cg.inviteCode}</b></div>
                <button onClick={() => { navigator.clipboard?.writeText(`${window.location.origin}/?join=${cg.inviteCode}`); showToast("Invite link copied!", "s"); }} style={{ background: "#0d0e00", border: "1px solid #8a6200", borderRadius: 8, padding: "7px 14px", color: "#F0B323", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Copy invite link</button>
              </div>
            )}
            {overBudget && (
              <div style={{ background: "#2a0d0d", border: "1px solid #4a1a1a", borderRadius: 12, padding: "10px 14px", marginBottom: 10, fontSize: 13, color: "#e07070" }}>
                You are ${(myTotal - budgetNum).toFixed(0)} over your ${budgetNum} budget!
              </div>
            )}
            <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
              {[{ l: "Total", v: `$${getTotal(cgItems).toFixed(0)}`, e: "💰" }, { l: "My Cost", v: `$${myTotal.toFixed(0)}`, e: "👤" }, { l: "Items", v: cgItems.length, e: "📦" }].map((s, i) => (
                <div key={i} style={{ flex: 1, background: "#0d0e00", border: "1px solid #2a2000", borderRadius: 14, padding: "10px 8px", textAlign: "center" }}>
                  <div style={{ fontSize: 16, marginBottom: 3 }}>{s.e}</div>
                  <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 15 }}>{s.v}</div>
                  <div style={{ fontSize: 10, color: "#6a5020", textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: 600 }}>{s.l}</div>
                </div>
              ))}
            </div>
            <input className="inp" placeholder="Search items..." value={searchQ} onChange={e => setSearchQ(e.target.value)} style={{ marginBottom: 10 }} />
          </div>

          {dupes.length > 0 && (
            <div style={{ padding: "0 24px", marginBottom: 12 }}>
              <div style={{ background: "#2a0d0d", border: "1px solid #4a1a1a", borderRadius: 12, padding: "10px 14px", display: "flex", gap: 8 }}>
                <span>⚠️</span>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13, color: "#e07070", marginBottom: 2 }}>Conflict Detected</div>
                  <div style={{ fontSize: 12, color: "#c05050" }}>{dupes.map(d => `"${d.charAt(0).toUpperCase() + d.slice(1)}"`).join(", ")} added by multiple people</div>
                </div>
              </div>
            </div>
          )}

          <div style={{ padding: "0 24px", marginBottom: 14 }}>
            <div className="tabs">
              {[
                { k: "list", l: "Items" },
                { k: "split", l: "Split" },
                { k: "checklist", l: "Check" },
                { k: "insights", l: "Smart" },
                ...(cg.mode === "household" ? [{ k: "house", l: "House" }] : []),
                { k: "settings", l: "More" },
              ].map(t => (
                <button key={t.k} className={`tab ${activeTab === t.k ? "tab-a" : "tab-i"}`} onClick={() => setActiveTab(t.k)}>{t.l}</button>
              ))}
            </div>
          </div>

          {/* ITEMS TAB */}
          {activeTab === "list" && (
            <div style={{ padding: "0 24px", display: "flex", flexDirection: "column", gap: 10 }}>
              {filteredItems.length === 0 && <div style={{ textAlign: "center", padding: 24, color: "#6a5020", fontSize: 14 }}>{searchQ ? "No items match your search" : "No items yet — add some below!"}</div>}
              {filteredItems.map(item => {
                const isDupe = dupes.includes(item.name.toLowerCase().trim());
                const isBanned = [...BANNED_ITEMS, ...(SCHOOL_BANNED[cg.school || profile.school] || [])].some(b => item.name.toLowerCase().includes(b.toLowerCase()));
                const ownerName = getDisplayName(item.owner);
                const isMine = item.owner === user?.uid;
                return (
                  <div key={item.id} className="row" style={{ borderColor: isDupe ? "#4a1a1a" : isBanned ? "#4a2a0a" : undefined }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4, flexWrap: "wrap" }}>
                        <div style={{ fontWeight: 600, fontSize: 14 }}>{item.name}</div>
                        {isDupe && <span style={{ fontSize: 10 }}>⚠️</span>}
                        {isBanned && <span className="tag tag-y" style={{ fontSize: 10, padding: "2px 6px" }}>banned?</span>}
                        {item.shared === false && <span className="tag tag-gray" style={{ fontSize: 10, padding: "2px 6px" }}>Personal</span>}
                      </div>
                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
                        <span style={{ fontSize: 13, color: "#c49020", fontWeight: 700 }}>${item.cost}</span>
                        {ownerName ? <span className="tag tag-g">✓ {ownerName}</span> : <span className="tag tag-gray">Unclaimed</span>}
                        
                        {item.purchased && <span className="tag tag-g" style={{ fontSize: 10, padding: "2px 6px" }}>Bought</span>}
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 6, flexShrink: 0 }}>
                      <button onClick={() => handleClaimTap(cg.id, item)} style={{ background: isMine ? "#0d2818" : "#0d0e00", border: `1px solid ${isMine ? "#1a4a30" : "#242010"}`, borderRadius: 8, padding: "5px 9px", cursor: "pointer", color: isMine ? "#4caf80" : "#6a5020", fontSize: 11, fontWeight: 700 }}>
                        {isMine ? "Mine" : "Claim"}
                      </button>
                      <button onClick={() => setEditItem({ ...item })} style={{ background: "#0d0e00", border: "1px solid #242010", borderRadius: 8, padding: "5px 9px", cursor: "pointer", color: "#c49020", fontSize: 11, fontWeight: 600 }}>Edit</button>
                    </div>
                  </div>
                );
              })}
              <button className="btn-p" onClick={() => setShowAddItem(true)}>+ Add Item</button>
              <button className="btn-g" onClick={() => setShowEssentials(true)}>Browse Essentials</button>
              <div style={{ display: "flex", gap: 10 }}>
                <button className="btn-g" onClick={exportList} style={{ flex: 1 }}>Share as Image</button>
                <button className="btn-g" onClick={copyList} style={{ flex: 1 }}>Copy List</button>
              </div>
              {activity.length > 0 && (
                <div style={{ marginTop: 8 }}>
                  <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 15, fontWeight: 700, marginBottom: 10, color: "#c49020" }}>Recent Activity</div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    {activity.slice(0, 5).map((a, i) => (
                      <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", background: "#0a0c00", border: "1px solid #2a2000", borderRadius: 12 }}>
                        <div style={{ fontSize: 13, color: "#d4c8a8" }}>{a.text}</div>
                        <div style={{ fontSize: 11, color: "#6a5020", whiteSpace: "nowrap", marginLeft: 10 }}>{timeAgo(a.ts)}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* SPLIT TAB */}
          {activeTab === "split" && (() => {
            const members = Object.entries(cg.memberNames || {});
            const memberSpend = members.map(([uid, name], i) => {
              const items = cgItems.filter(it => it.owner === uid);
              return { uid, name: uid === user.uid ? "You" : name, value: getTotal(items), items, color: MEMBER_COLORS[i % MEMBER_COLORS.length] };
            });
            const claimedTotal = memberSpend.reduce((s, m) => s + m.value, 0);
            const unclaimed = getTotal(cgItems.filter(it => !it.owner));
            const pieData = memberSpend.filter(m => m.value > 0);
            return (
              <div style={{ padding: "0 24px", display: "flex", flexDirection: "column", gap: 16 }}>
                {pieData.length > 0 ? (
                  <div style={{ background: "linear-gradient(145deg,#0d0e00,#0a0c00)", border: "1px solid #2a2000", borderRadius: 20, padding: 20, display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
                    <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 16, alignSelf: "flex-start" }}>Cost Breakdown</div>
                    <PieChart data={pieData} total={claimedTotal} />
                    <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 8 }}>
                      {pieData.map((m, i) => (
                        <div key={i} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <div style={{ width: 10, height: 10, borderRadius: "50%", background: m.color, flexShrink: 0 }} />
                          <div style={{ flex: 1, fontSize: 14, fontWeight: 600 }}>{m.name}</div>
                          <div style={{ fontSize: 14, color: "#c49020", fontWeight: 700 }}>${m.value.toFixed(0)}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div style={{ background: "#0d0e00", border: "1px solid #2a2000", borderRadius: 20, padding: 24, textAlign: "center", color: "#6a5020", fontSize: 14 }}>Claim items to see the split breakdown</div>
                )}

                {/* SETTLE UP */}
                {settlements.length > 0 && (
                  <div style={{ background: "#0d0e00", border: "1px solid #3d2e00", borderRadius: 16, padding: 16 }}>
                    <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 15, marginBottom: 4 }}>⚖️ Settle Up</div>
                    <div style={{ fontSize: 12, color: "#6a5020", marginBottom: 12 }}>Based on shared items only — even split across the group</div>
                    {settlements.map((s, i) => {
                      
                      return (
                        <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 0", borderTop: i > 0 ? "1px solid #2a2000" : "none" }}>
                          <div style={{ flex: 1, fontSize: 14 }}>
                            <b>{s.from.name}</b> owes <b>{s.to.name}</b>
                          </div>
                          <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, color: "#F0B323" }}>${s.amt.toFixed(2)}</div>
                          <button onClick={() => { navigator.clipboard?.writeText(`${s.from.name} owes ${s.to.name} $${s.amt.toFixed(2)} (Haulmate settle-up)`); showToast("Copied!", "s"); }} style={{ background: "#0d0e00", border: "1px solid #242010", borderRadius: 8, padding: "5px 10px", color: "#c49020", fontSize: 11, fontWeight: 600, cursor: "pointer" }}>Copy</button>
                        </div>
                      );
                    })}
                  </div>
                )}

                {memberSpend.map((m, i) => (
                  <div key={i} style={{ background: "#0a0c00", border: `1px solid ${m.items.length > 0 ? m.color + "44" : "#2a2000"}`, borderRadius: 16, padding: 16 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: m.items.length ? 12 : 0 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div style={{ width: 30, height: 30, borderRadius: "50%", background: `${m.color}22`, border: `2px solid ${m.color}66`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, color: m.color }}>{m.name[0]}</div>
                        <div style={{ fontWeight: 700, fontSize: 14 }}>{m.name}</div>
                      </div>
                      <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 17, color: m.value > 0 ? m.color : "#6a5020" }}>${m.value.toFixed(0)}</div>
                    </div>
                    {m.items.map((it, j) => (
                      <div key={j} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderTop: "1px solid #2a2000", fontSize: 13 }}>
                        <span style={{ color: "#d4c8a8" }}>{it.name}{it.shared === false ? " (personal)" : ""}</span>
                        <span style={{ color: "#c49020", fontWeight: 600 }}>${Number(it.cost).toFixed(0)}</span>
                      </div>
                    ))}
                    {m.items.length === 0 && <div style={{ fontSize: 13, color: "#6a5020", fontStyle: "italic" }}>No items claimed</div>}
                  </div>
                ))}
                {unclaimed > 0 && (
                  <div style={{ background: "#0d0e00", border: "1px solid #2a2010", borderRadius: 14, padding: 14, display: "flex", justifyContent: "space-between" }}>
                    <div style={{ fontSize: 13, color: "#e0a050", fontWeight: 600 }}>Unclaimed</div>
                    <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 16, color: "#e0a050" }}>${unclaimed.toFixed(0)}</div>
                  </div>
                )}
              </div>
            );
          })()}

          {/* CHECKLIST TAB */}
          {activeTab === "checklist" && (
            <div style={{ padding: "0 24px", display: "flex", flexDirection: "column", gap: 10 }}>
              <div style={{ textAlign: "center", padding: "12px 0", fontSize: 13, color: "#c49020", fontWeight: 600 }}>
                {cgItems.filter(i => i.checked).length}/{cgItems.length} items packed
              </div>
              {cgItems.map(item => (
                <div key={item.id} className="row" style={{ opacity: item.checked ? 0.45 : 1, cursor: "pointer" }} onClick={() => toggleCheck(cg.id, item)}>
                  <div style={{ width: 22, height: 22, borderRadius: 6, border: `2px solid ${item.checked ? "#F0B323" : "#4a3800"}`, background: item.checked ? "#3d2e00" : "transparent", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    {item.checked && <span style={{ fontSize: 12, color: "#F0B323" }}>✓</span>}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 14, fontWeight: 600, textDecoration: item.checked ? "line-through" : "none", color: item.checked ? "#6a5020" : "#f5f0e0" }}>{item.name}</div>
                    <div style={{ fontSize: 12, color: "#6a5020" }}>${item.cost} · {getDisplayName(item.owner) || "Unclaimed"}</div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* INSIGHTS TAB */}
          {activeTab === "insights" && (
            <div style={{ padding: "0 24px", display: "flex", flexDirection: "column", gap: 14 }}>
              <div style={{ background: "#0d0e00", border: "1px solid #2a2000", borderRadius: 16, padding: 18 }}>
                <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 15, marginBottom: 4 }}>🔍 Coverage Gaps</div>
                <div style={{ fontSize: 12, color: "#6a5020", marginBottom: 12 }}>Common essentials nobody in your group has yet</div>
                {coverageGaps.length === 0 ? (
                  <div style={{ fontSize: 14, color: "#4caf80" }}>✓ Your group covers all the key essentials!</div>
                ) : coverageGaps.map((g, i) => (
                  <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 0", borderTop: i > 0 ? "1px solid #2a2000" : "none" }}>
                    <div style={{ flex: 1, fontSize: 14 }}>{g.name}</div>
                    <span style={{ fontSize: 12, color: "#c49020", fontWeight: 700 }}>~${g.cost}</span>
                    <button onClick={() => handleAddEssentials(cg.id, [g])} style={{ background: "#1a1400", border: "1px solid #3d2e00", borderRadius: 8, padding: "5px 10px", color: "#F0B323", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>+ Add</button>
                  </div>
                ))}
              </div>

              <div style={{ background: "#0d0e00", border: "1px solid #2a2000", borderRadius: 16, padding: 18 }}>
                <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 15, marginBottom: 4 }}>🚗 Car Space Estimate</div>
                <div style={{ fontSize: 12, color: "#6a5020", marginBottom: 10 }}>Rough volume of everything on the list</div>
                <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 26, fontWeight: 700, color: "#F0B323" }}>~{totalCuft.toFixed(0)} cu ft</div>
                <div style={{ fontSize: 13, color: "#c49020", marginTop: 4 }}>≈ {trunks} car trunk{trunks !== 1 ? "s" : ""} worth of stuff{trunks > 2 ? " — consider an SUV or two trips!" : ""}</div>
              </div>

              <button className="btn-p" onClick={() => setShowQuestionnaire(true)}>✨ Smart Starter List</button>
              {moveInDays !== null && <button className="btn-g" onClick={() => setShowMoveInMode(true)}>🚚 Open Move-In Day Mode</button>}
            </div>
          )}

          {/* HOUSE TAB */}
          {activeTab === "house" && cg.mode === "household" && (
            <div style={{ padding: "0 24px", display: "flex", flexDirection: "column", gap: 12 }}>
              <div style={{ fontSize: 13, color: "#c49020" }}>Shared household list — groceries, supplies, anything you're out of.</div>
              <div style={{ display: "flex", gap: 8 }}>
                <input className="inp" placeholder="We're out of..." value={groceryInput} onChange={e => setGroceryInput(e.target.value)} onKeyDown={e => e.key === "Enter" && addGrocery()} />
                <button onClick={addGrocery} style={{ background: "#1a1400", border: "1px solid #3d2e00", borderRadius: 12, padding: "0 18px", color: "#F0B323", fontSize: 20, fontWeight: 700, cursor: "pointer", flexShrink: 0 }}>+</button>
              </div>
              {cgGrocery.length === 0 && <div style={{ textAlign: "center", padding: 24, color: "#6a5020", fontSize: 14 }}>Nothing needed right now 🎉</div>}
              {cgGrocery.map(item => (
                <div key={item.id} className="row" style={{ opacity: item.checked ? 0.45 : 1 }}>
                  <div onClick={() => toggleCheck(cg.id, item)} style={{ width: 22, height: 22, borderRadius: 6, border: `2px solid ${item.checked ? "#F0B323" : "#4a3800"}`, background: item.checked ? "#3d2e00" : "transparent", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, cursor: "pointer" }}>
                    {item.checked && <span style={{ fontSize: 12, color: "#F0B323" }}>✓</span>}
                  </div>
                  <div style={{ flex: 1, fontSize: 14, fontWeight: 600, textDecoration: item.checked ? "line-through" : "none" }}>{item.name}</div>
                  <span style={{ fontSize: 11, color: "#6a5020" }}>{item.addedByName}</span>
                  <button onClick={() => deleteItemDB(cg.id, item.id)} style={{ background: "none", border: "none", color: "#6a5020", fontSize: 16, cursor: "pointer" }}>x</button>
                </div>
              ))}
            </div>
          )}

          {/* MORE/OPTIONS TAB */}
          {activeTab === "settings" && (
            <div style={{ padding: "0 24px", display: "flex", flexDirection: "column", gap: 14 }}>
              <div style={{ background: "#0d0e00", border: "1px solid #2a2000", borderRadius: 16, padding: 18 }}>
                <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 15, marginBottom: 14 }}>Move-In Date</div>
                <input className="inp" type="date" value={cg.moveInDate || ""} onChange={e => updateGroup(cg.id, { moveInDate: e.target.value })} style={{ minHeight: 48, textAlign: "left", colorScheme: "dark", width: "100%", maxWidth: "100%" }} />
                {cg.moveInDate && <div style={{ fontSize: 12, color: "#c49020", marginTop: 8 }}>📅 {new Date(cg.moveInDate + "T00:00:00").toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" })}</div>}
              </div>
              <div style={{ background: "#0d0e00", border: "1px solid #2a2000", borderRadius: 16, padding: 18 }}>
                <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 15, marginBottom: 14 }}>Budget Cap</div>
                <input className="inp" type="number" placeholder="Your personal budget ($)" value={budgetCap} onChange={e => setBudgetCap(e.target.value)} />
                {budgetCap && <div style={{ fontSize: 13, color: overBudget ? "#e07070" : "#4caf80", marginTop: 8, fontWeight: 600 }}>
                  ${myTotal.toFixed(0)} of ${budgetCap} {overBudget ? "— OVER BUDGET!" : "— on track"}
                </div>}
              </div>
              <div style={{ background: "#0d0e00", border: "1px solid #2a2000", borderRadius: 16, padding: 18 }}>
                <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 15, marginBottom: 14 }}>Dorm Dimensions</div>
                <select className="inp" style={{ marginBottom: 10 }} value={cg.hall || ""} onChange={e => {
                  const presets = DORM_PRESETS[cg.school || profile.school] || DORM_PRESETS.UMBC;
                  const h = presets.find(x => x.name === e.target.value);
                  if (h) {
                    const keys = Object.keys(h.types);
                    if (keys.length === 1) {
                      const d = h.types[keys[0]];
                      updateGroup(cg.id, { hall: h.name, roomType: keys[0], dormDimensions: { length: d.length, width: d.width } });
                    } else {
                      updateGroup(cg.id, { hall: h.name, roomType: "" });
                    }
                  } else {
                    updateGroup(cg.id, { hall: "", roomType: "" });
                  }
                }}>
                  <option value="">Pick your hall (auto-fills size)</option>
                  {(DORM_PRESETS[cg.school || profile.school] || DORM_PRESETS.UMBC).map(h => <option key={h.name} value={h.name}>{h.name}</option>)}
                </select>
                {(() => {
                  const presets = DORM_PRESETS[cg.school || profile.school] || DORM_PRESETS.UMBC;
                  const h = presets.find(x => x.name === cg.hall);
                  if (!h) return null;
                  const keys = Object.keys(h.types);
                  return (
                    <>
                      {keys.length > 1 && (
                        <select className="inp" style={{ marginBottom: 10 }} value={cg.roomType || ""} onChange={e => {
                          const d = h.types[e.target.value];
                          if (d) updateGroup(cg.id, { roomType: e.target.value, dormDimensions: { length: d.length, width: d.width } });
                        }}>
                          <option value="">Room type...</option>
                          {keys.map(t => <option key={t} value={t}>{t} ({h.types[t].width}x{h.types[t].length} ft)</option>)}
                        </select>
                      )}
                      {h.note && <div style={{ fontSize: 12, color: "#6a5020", marginBottom: 8 }}>* {h.note}</div>}
                      {h.estimated && <div style={{ fontSize: 12, color: "#6a5020", marginBottom: 8 }}>* Estimated sizes — edit below if you know yours</div>}
                    </>
                  );
                })()}
                <div style={{ display: "flex", gap: 10 }}>
                  <input className="inp" type="number" placeholder="Length (ft)" value={cg.dormDimensions?.length || ""} onChange={e => updateGroup(cg.id, { dormDimensions: { ...cg.dormDimensions, length: Number(e.target.value) } })} />
                  <input className="inp" type="number" placeholder="Width (ft)" value={cg.dormDimensions?.width || ""} onChange={e => updateGroup(cg.id, { dormDimensions: { ...cg.dormDimensions, width: Number(e.target.value) } })} />
                </div>
                <div style={{ fontSize: 12, color: "#6a5020", marginTop: 8 }}>Room size: {(cg.dormDimensions?.length || 14) * (cg.dormDimensions?.width || 12)} sq ft</div>
              </div>
              <div style={{ background: "#0d0e00", border: "1px solid #2a2000", borderRadius: 16, padding: 18 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 15 }}>Household Mode</div>
                    <div style={{ fontSize: 12, color: "#6a5020" }}>After move-in: shared grocery & supply list</div>
                  </div>
                  <button className={`tgl ${cg.mode === "household" ? "tgl-on" : "tgl-off"}`} onClick={() => updateGroup(cg.id, { mode: cg.mode === "household" ? "movein" : "household" })} />
                </div>
              </div>
              <div style={{ background: "#0d0e00", border: "1px solid #2a2000", borderRadius: 16, padding: 18 }}>
                <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 15, marginBottom: 14 }}>Invite Code</div>
                <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 26, fontWeight: 700, letterSpacing: 4, color: "#F0B323", marginBottom: 4 }}>{cg.inviteCode || "..."}</div>
                <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
                  <button className="btn-g" style={{ fontSize: 13, padding: "10px", flex: 1 }} onClick={() => { navigator.clipboard?.writeText(cg.inviteCode); showToast("Code copied!", "s"); }}>Copy Code</button>
                  <button className="btn-g" style={{ fontSize: 13, padding: "10px", flex: 1 }} onClick={() => { navigator.clipboard?.writeText(`${window.location.origin}/?join=${cg.inviteCode}`); showToast("Invite link copied!", "s"); }}>Copy Link</button>
                </div>
              </div>
              <button className="btn-g" onClick={() => setShowMoveOut(true)}>📤 Move-Out Planner</button>
              {cg.createdBy === user?.uid ? (
                <button className="btn-danger" onClick={() => handleDeleteGroup(cg.id)}>Delete Group</button>
              ) : (
                <button className="btn-danger" onClick={() => handleLeaveGroup(cg.id)}>Leave Group</button>
              )}
            </div>
          )}
        </div>
      )}

      {/* PROFILE */}
      {navTab === "profile" && (
        <div style={{ flex: 1, overflowY: "auto", paddingBottom: 80 }}>
          <div style={{ padding: "52px 24px 24px" }}>
            <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 22, fontWeight: 700, marginBottom: 24 }}>Profile</div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, marginBottom: 28 }}>
              <div style={{ width: 72, height: 72, borderRadius: "50%", background: "linear-gradient(135deg,#3d2e00,#1a1400)", border: "2px solid #F0B323", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28, fontWeight: 700, color: "#F0B323" }}>
                {profile.name ? profile.name[0].toUpperCase() : "?"}
              </div>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 20, fontWeight: 700 }}>{profile.name || "Your Name"}</div>
              <div style={{ fontSize: 14, color: "#c49020" }}>{profile.school || "No school set"}</div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 24 }}>
              {[
                { l: "Groups", v: groups.length },
                { l: "In My Cart", v: myCart.length },
                { l: "My Spend", v: `$${getTotal(myCart).toFixed(0)}` },
                { l: "Bought", v: myCart.filter(i => i.purchased).length },
              ].map((s, i) => (
                <div key={i} style={{ background: "#0d0e00", border: "1px solid #2a2000", borderRadius: 14, padding: "14px 16px", textAlign: "center" }}>
                  <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 22, marginBottom: 4 }}>{s.v}</div>
                  <div style={{ fontSize: 12, color: "#6a5020", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>{s.l}</div>
                </div>
              ))}
            </div>
            <div style={{ background: "#0d0e00", border: "1px solid #2a2000", borderRadius: 16, padding: 18, marginBottom: 14 }}>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 15, marginBottom: 14 }}>Edit Profile</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                <input className="inp" placeholder="Your name" value={profile.name} onChange={e => setProfile(p => ({ ...p, name: e.target.value }))} />
                <select className="inp" value={profile.school} onChange={e => setProfile(p => ({ ...p, school: e.target.value }))}>
                  <option value="">Select school...</option>
                  {SCHOOLS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                </select>
                
                <button className="btn-p" onClick={handleSaveProfile}>Save Profile</button>
              </div>
            </div>
            {user?.uid === ADMIN_UID && (
              <button className="btn-p" style={{ marginBottom: 10 }} onClick={() => setShowAdminPanel(true)}>🛠️ Admin Panel</button>
            )}
            <button className="btn-danger" style={{ marginBottom: 14 }} onClick={() => signOut(auth)}>Sign Out</button>
            <div style={{ background: "#0d0e00", border: "1px solid #2a2000", borderRadius: 16, padding: 18 }}>
              <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 15, marginBottom: 16 }}>Settings</div>
              {[
                { label: "Delete Confirmations", sub: "Show 'Are you sure?' popups", val: confirmDelete, set: setConfirmDelete },
                { label: "Notifications", sub: "Group activity alerts", val: notifications, set: setNotifications },
              ].map((s, i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: i < 1 ? 14 : 0, marginBottom: i < 1 ? 14 : 0, borderBottom: i < 1 ? "1px solid #2a2000" : "none" }}>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>{s.label}</div>
                    <div style={{ fontSize: 12, color: "#6a5020" }}>{s.sub}</div>
                  </div>
                  <button className={`tgl ${s.val ? "tgl-on" : "tgl-off"}`} onClick={() => s.set(!s.val)} />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* BOTTOM NAV */}
      <div className="bnav">
        {[
          { icon: "🏠", label: "Home", k: "home" },
          { icon: "🛒", label: cartUnbought > 0 ? `Cart (${cartUnbought})` : "Cart", k: "cart" },
          { icon: "➕", label: "New Group", k: "new" },
          { icon: "👤", label: "Profile", k: "profile" },
        ].map(n => (
          <div key={n.k} className={`ni ${navTab === n.k ? "a" : ""}`} onClick={() => { if (n.k === "new") setShowAddGroup(true); else setNavTab(n.k); }}>
            <span style={{ fontSize: 20 }}>{n.icon}</span>
            <span>{n.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
